import Web3 from 'web3';
import React from 'react';
import imgs from './ImgFactory.js';
import TokensInfo from './TokensInfo.js';
import swal from 'sweetalert';
import bznTrunk from './images/BZN-truck.png';
import loadingGif from './images/loading.gif';
import { Bitski } from 'bitski';
import trustwallet from './images/trustwallet.png';
import metamask from './images/metamask.png';
import { isIOS } from 'react-device-detect';
import firebase from './firebase.js';
import evCar from './images/war-ev-large.jpg';
import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";
import { WalletLink } from 'walletlink';
import walletLinkLogo from './images/coinbase-wallet.svg';
import { ethers } from "ethers";

var CONTRACTDEBUG = false;
var activeChainId = !CONTRACTDEBUG ? 1 : 4;
var BITSKIDEBUG = false;
var USEINFURA = false;
var USECHAINSTACK = false;
let redirect = 'https://app.warriders.com/?callback=true';
let infuraNetwork = 'mainnet';
let infuraKey = '1d1b2ecceca248fba8255355a6b07f26';
if (CONTRACTDEBUG) {
  infuraNetwork = 'rinkeby';
  infuraKey = '48e63daff59f4a1ea3ebe20fbade0e75';
}
if (BITSKIDEBUG) {
  redirect = 'http://localhost:3000/?callback=true';
}
var bitskiInstance = new Bitski('983fecac-6f9a-4fe9-ad49-15d92fd28c8f', redirect);
if (BITSKIDEBUG) {
  bitskiInstance = new Bitski();
}

var bitProvider;
if (!USEINFURA) {
  if (!USECHAINSTACK) {
    bitProvider = bitskiInstance.getProvider({disableBlockTracking: true});
    if (BITSKIDEBUG) {
      bitProvider = bitskiInstance.getProvider({ networkName: 'rinkeby', disableBlockTracking: true });
    }
  } else {
    //m1iRwXFq.vcBjME3w5bpkX25jtq99Jqfgq3OW4WLC
    bitProvider = new Web3.providers.WebsocketProvider("");
  }
} else {
  if (CONTRACTDEBUG) {
    bitProvider = new Web3.providers.HttpProvider("");
  } else {
    bitProvider = new Web3.providers.HttpProvider(`https://${infuraNetwork}.infura.io/v3/${infuraKey}`);
  }
}

var web3 = new Web3(Web3.givenProvider || Web3.currentProvider || bitProvider);
var eweb3 = ethers.getDefaultProvider('mainnet', {
  alchemy: 'irJP35twUTUUNxjP-_4q_ExlMSSnqQrA'
});
var infoWeb3 = new Web3(bitProvider);
var isEnabled = false;
var isLocked = false;
var isBitski = false;

function completeWeb3(enabled) {
  if (isEnabled) return; //Don't update vars if we already enabled

  isEnabled = enabled;
  isLocked = !enabled;

  if (isEnabled) {
    setupContracts();
  }
}

const timeout = (cb, interval) => {
  return new Promise((resolve) => {
    setTimeout(() => cb(resolve), interval);
  });
};

const enableWeb3 = (cb, ethereum) => {
  return new Promise((resolve) => {
    ethereum.enable().then(() => {
      cb(resolve);
    });
  })
}

async function metamaskLocked() {
  let tryAgain = await swal({
    title: "Please Unlock Account",
    text: "It seems your account is locked.\nPlease unlock or login your account in order to take full advantange of the Wasteland.",
    icon: "warning",
    buttons: ["Continue Without Web3", "Retry"]
  });

  if (tryAgain) {
    await web3Browser();
  } else {
    completeWeb3(false);
  }
}

async function windowEthereumConnected() {
  if (window.ethereum) {
    let web3Test = new Web3(window.ethereum);
    let accounts = await web3Test.eth.getAccounts();
    let hasAccounts = accounts.length > 0;

    return hasAccounts;
  }

  return false;
}

async function web3Browser() {
  // Modern dapp browsers...
  if (window.ethereum) {
      web3 = new Web3(window.ethereum);
      eweb3 = new ethers.providers.Web3Provider(window.ethereum);
      variables.web3 = web3;
      variables.eweb3 = eweb3;

      let chainId = Number(await web3.eth.getChainId());

      console.log(chainId + "   :   " + activeChainId)

      while (chainId !== activeChainId) {
        try {
          let decidePromise = swal({
            title: "Wrong Network",
            text: "It seems your wallet is connected to the wrong network, please switch networks and try again",
            icon: "warning",
            buttons: {
              noweb3: {
                text: "Continue Without Web3",
                value: "cancel",
              },
              retry: true,
              change: {
                text: "Change Wallet",
                value: "change",
              }
            },
            closeOnClickOutside: false
          });

          let resultPromise = window.ethereum.request({
            method: "wallet_switchEthereumChain",
            params: [{
                chainId: "0x" + activeChainId.toString(16),
            }]
          });

          const result = await Promise.race([resultPromise, decidePromise]);

          console.log("RESULT: " + result);

          if (result == null || result == "retry") {
            // Reset provider with new chain
            web3 = new Web3(window.ethereum);
            eweb3 = new ethers.providers.Web3Provider(window.ethereum);
            variables.web3 = web3;
            variables.eweb3 = eweb3;

            chainId = Number(await web3.eth.getChainId());
            
            swal.close();
            continue; //Verify and try again
          } else if (result == "cancel") {
            completeWeb3(false);
            return;
          } else if (result == "change") {
            ignoreInjectedProvider = true;
            askForInjection();
            return;
          } else {
            throw result;
          }
        } catch (e) {
          console.log(e);
          metamaskLocked();
          return;
        }
      }

      let accounts = await web3.eth.getAccounts();
      let hasAccounts = accounts.length > 0;
      if (!hasAccounts) {
        try {
            swal({
              title: "Loading...",
              text: "Please wait while you connect to the Wasteland...",
              icon: loadingGif,
              className: 'wr-loader',
              button: false,
              closeOnClickOutside: false
            });
            let didWeEnabled = false;
            //Show locked message when 10 seconds pass
            let onWeb3Timeout = timeout((resolve) => {
              if (!didWeEnabled) {
                metamaskLocked();
                resolve(false);
              }
            }, 10000);

            // Request account access if needed, and resolve true when enabled
            let onEnableWeb3 = enableWeb3((resolve) => {
              didWeEnabled = true;
              swal.close();
              completeWeb3(true);
              resolve(true);
            }, window.ethereum);

            //Race the two conditions above and choose whichever one resolves first
            const success = await Promise.race([onEnableWeb3, onWeb3Timeout]);

            return success;
        } catch (error) {
          completeWeb3(false);
          return false;
        }
      } else {
        completeWeb3(true);
        return true;
      }
  }
  else if (window.web3) {
      web3 = new Web3(window.web3.currentProvider);
      eweb3 = new ethers.providers.Web3Provider(window.web3.currentProvider);
      variables.web3 = web3;
      variables.eweb3 = eweb3;
      await wait(300);
      completeWeb3(true);
      return true;
  } else {
    await wait(300);
    completeWeb3(false);
    return false;
  }
}

const infuraId = "1fdd2db1469a4aae8909b8e4075ddc5c"
const chainId = CONTRACTDEBUG ? 4 : 1;

const providerOptions = {
  walletconnect: {
    package: WalletConnectProvider, // required
    options: {
      /* rpc: {
        1: "https://eth-mainnet.alchemyapi.io/v2/irJP35twUTUUNxjP-_4q_ExlMSSnqQrA"
      }, */
      infuraId: infuraId, // required
      clientMeta: {
        description: 'War Riders is the first MMO game of earning cryptocurrency and blowing up cars.',
        name: 'WarRiders',
        icons: ['https://app.warriders.com/favicon.ico'],
        url: 'https://app.warriders.com'
      }
    }
  },
  bitski: {
    package: Bitski, // required
    options: {
      clientId: "983fecac-6f9a-4fe9-ad49-15d92fd28c8f",
      callbackUrl: redirect 
    }
  },
  'custom-walletlink': {
    display: {
      logo: walletLinkLogo, // Path to wallet link logo. Source https://github.com/walletlink/walletlink/blob/master/web/src/images/wallets/coinbase-wallet.svg
      name: 'WalletLink',
      description: 'Scan with WalletLink to connect',
    },
    options: {
      appName: 'WarRiders', // Your app name
      //networkUrl: "https://eth-mainnet.alchemyapi.io/v2/irJP35twUTUUNxjP-_4q_ExlMSSnqQrA",
      networkUrl: `https://mainnet.infura.io/v3/${infuraId}`,
      chainId,
    },
    package: WalletLink,
    connector: async (_, options) => {
      const { appName, networkUrl, chainId } = options
      const walletLink = new WalletLink({
        appName
      });
      const provider = walletLink.makeWeb3Provider(networkUrl, chainId);
      await provider.enable();
      return provider;
    },
  },
};

var web3Modal = null;
var provider = null;
var isConnecting = false;
var ignoreInjectedProvider = false;
var disconnectCallbacks = [];

function disconnectWeb3() {
  isEnabled = false;
  isLocked = false;

  try {
    web3.currentProvider.disconnect();
  } catch (e) {
    console.log(e);
  }

  web3 = new Web3(Web3.givenProvider || Web3.currentProvider || bitProvider);
  eweb3 = ethers.getDefaultProvider('mainnet', {
    alchemy: 'irJP35twUTUUNxjP-_4q_ExlMSSnqQrA'
  });;

  variables.web3 = web3;
  variables.eweb3 = eweb3;

  if (web3Modal != null) {
    web3Modal.clearCachedProvider();
  }

  try {
    localStorage.removeItem('walletconnect');
  } catch (e) {
    console.log(e);
  }
  for (let i = 0; i < disconnectCallbacks.length; i++) {
    disconnectCallbacks[i]();
  }
}


function applyWeb3() {
  if (provider == null)
    return;

  web3 = new Web3(provider);
  eweb3 = new ethers.providers.Web3Provider(provider);

  variables.web3 = web3;
  variables.eweb3 = eweb3;

  completeWeb3(true);
}

async function askForInjection() {
  let alreadyInjected = await windowEthereumConnected();
  if (alreadyInjected && !ignoreInjectedProvider) {
    await web3Browser();
    return;
  }

  let answer = await swal({
    title: "Which wallet would you like to use?",
    text: "It seems your browser already has a wallet, would you like to connect using your browser wallet?",
    icon: "info",
    buttons: {
      confirm: {
        text: 'Connect With Browser Wallet',
        value: 0,
      },
      other: {
        text: 'Connect Another Wallet',
        value: 1,
      },
      cancel: "Continue Without a Wallet"
    },
    closeOnClickOutside: false,
    closeOnEsc: false,
  });

  console.log(answer);

  if (answer === 0) {
    ignoreInjectedProvider = false;
    await web3Browser();
  } else if (answer === 1) {
    await activateWeb3Modal(askForInjection);
    ignoreInjectedProvider = false;
  } else {
    ignoreInjectedProvider = false;
    completeWeb3(false);
  }
}

async function initWeb3() {
  if (web3Modal == null) {
    web3Modal = new Web3Modal({
      network: CONTRACTDEBUG ? 'rinkeby': 'mainnet',
      cacheProvider: true,
      theme: "dark",
      providerOptions
    });
  }

  if (window.ethereum || window.web3) {
    await web3Browser();
  }
}

async function activateWeb3Modal(cancelCallback = null) {
  if (isConnecting) {
    //swal('Already Awaiting Connecting', "Cant activate modal because it's already active", "error");
    return;
  }

  isConnecting = true;

  try {
    if (web3Modal == null) {
      //Let's just create it now if it's null for some reason
      web3Modal = new Web3Modal({
        network: CONTRACTDEBUG ? 'rinkeby': 'mainnet',
        cacheProvider: true,
        theme: "dark",
        providerOptions
      });
    }
    provider = await web3Modal.connect();
    //swal('Success', 'Got provider', 'info');
  } catch(e) {
    console.log("Got error in activateWeb3Modal - " + e)
    //swal('Error', 'We found an Error: ' + e + '\n' + e.message + '\n' + e.description, 'error');
    if (cancelCallback) {
      isConnecting = false;
      await cancelCallback();
    } else {
      const success = await web3Browser();
      isConnecting = false;
      if (!success) {
        disconnectWeb3(); //Ensure we are disconnected
      }
    }
    return;
  }

  isConnecting = false;

  applyWeb3(provider);
}

window.addEventListener('load', async () => {
    await initWeb3();
});


var contract_abis = {
    car_tkn: [{"anonymous":false,"inputs":[{"indexed":true,"name":"_owner","type":"address"},{"indexed":true,"name":"_operator","type":"address"},{"indexed":false,"name":"_approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_tokenId","type":"uint256"}],"name":"approve","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_tokenId","type":"uint256"},{"name":"_metadata","type":"string"},{"name":"cType","type":"uint256"},{"name":"tankSize","type":"uint256"},{"name":"newOwner","type":"address"}],"name":"mint","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_tokenId","type":"uint256"},{"name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"anonymous":false,"inputs":[{"indexed":true,"name":"_from","type":"address"},{"indexed":true,"name":"_to","type":"address"},{"indexed":true,"name":"_tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"previousOwner","type":"address"},{"indexed":true,"name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"previousOwner","type":"address"}],"name":"OwnershipRenounced","type":"event"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"anonymous":false,"inputs":[{"indexed":true,"name":"_owner","type":"address"},{"indexed":true,"name":"_approved","type":"address"},{"indexed":true,"name":"_tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"inputs":[{"name":"factoryAddress","type":"address"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"constant":true,"inputs":[{"name":"_owner","type":"address"}],"name":"balanceOf","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"}],"name":"carType","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"}],"name":"carTypeSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"}],"name":"carTypeTotalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"DUNE_BUGGY","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_tokenId","type":"uint256"}],"name":"exists","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"tokenId","type":"uint256"}],"name":"getCarType","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"variant","type":"uint256"}],"name":"getMidgradeCarsForVariant","outputs":[{"name":"","type":"uint256[]"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"variant","type":"uint256"}],"name":"getMidgradeCarSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"variant","type":"uint256"}],"name":"getPremiumCarsForVariant","outputs":[{"name":"","type":"uint256[]"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"variant","type":"uint256"}],"name":"getPremiumCarSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"variant","type":"uint256"}],"name":"getRegularCarsForVariant","outputs":[{"name":"","type":"uint256[]"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"variant","type":"uint256"}],"name":"getRegularCarSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"cType","type":"uint256"}],"name":"getTotalSupplyForType","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"HATCHBACK","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"HOVERCRAFT_TYPE","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"InterfaceId_ERC165","outputs":[{"name":"","type":"bytes4"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"tokenId","type":"uint256"}],"name":"isCarSpecial","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"cType","type":"uint256"}],"name":"isMidGrade","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"pure","type":"function"},{"constant":true,"inputs":[{"name":"cType","type":"uint256"}],"name":"isPremium","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"pure","type":"function"},{"constant":true,"inputs":[{"name":"cType","type":"uint256"}],"name":"isRegular","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"pure","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"}],"name":"isSpecial","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"}],"name":"isTypeSpecial","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"LAMBO_TYPE","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"}],"name":"maxBznTankSizeOfMidGradeCarWithIndex","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"}],"name":"maxBznTankSizeOfPremiumCarWithIndex","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"}],"name":"maxBznTankSizeOfRegularCarWithIndex","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"}],"name":"maxTankSizes","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"METADATA_URL","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"MIDGRADE_TYPE_COUNT","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"MIDGRADE_TYPE2","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"MIDGRADE_TYPE3","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"},{"name":"","type":"uint256"}],"name":"midGradeTotalSupplyForCar","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"PREMIUM_TYPE_COUNT","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"},{"name":"","type":"uint256"}],"name":"premiumTotalSupplyForCar","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"REGULAR_TYPE_COUNT","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"REGULAR_TYPE2","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"REGULAR_TYPE3","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"},{"name":"","type":"uint256"}],"name":"regularTotalSupplyForCar","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"SUV_TYPE","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"TANK_TYPE","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"TANKER_TYPE","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"}],"name":"tankSizes","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_index","type":"uint256"}],"name":"tokenByIndex","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_index","type":"uint256"}],"name":"tokenOfOwnerByIndex","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"UNKNOWN_TYPE","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"}],
    car_token_factory: [{"constant":false,"inputs":[{"name":"dst","type":"address"}],"name":"attachPreOrder","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"dst","type":"address"}],"name":"attachToken","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_tokenId","type":"uint256"},{"name":"_tankSize","type":"uint256"},{"name":"cType","type":"uint256"},{"name":"markCar","type":"bool"},{"name":"dst","type":"address"}],"name":"giveaway","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"anonymous":false,"inputs":[{"indexed":true,"name":"previousOwner","type":"address"},{"indexed":true,"name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[],"name":"CarSellingBeings","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"_tokenId","type":"uint256"},{"indexed":false,"name":"_metadata","type":"string"},{"indexed":false,"name":"cType","type":"uint256"}],"name":"CarMinted","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"previousOwner","type":"address"}],"name":"OwnershipRenounced","type":"event"},{"constant":false,"inputs":[{"name":"cType","type":"uint256"},{"name":"newOwner","type":"address"}],"name":"mintFor","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_tokenIds","type":"uint256[]"},{"name":"ts","type":"uint256[]"},{"name":"cTypes","type":"uint256[]"}],"name":"setTokenMeta","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"},{"name":"","type":"uint256"}],"name":"availableIds","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"}],"name":"giveawayCar","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"}],"name":"idCursor","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"MAX_CARS","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"mintedCars","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"}],"name":"savedTypes","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"}],"name":"tankSizes","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"}],
    preorder: [{"constant":false,"inputs":[{"name":"referal","type":"address"},{"name":"variants","type":"uint256[]"},{"name":"new_owner","type":"address"}],"name":"buyBulkMidGradeCar","outputs":[{"name":"","type":"bool"}],"payable":true,"stateMutability":"payable","type":"function"},{"constant":false,"inputs":[{"name":"referal","type":"address"},{"name":"variants","type":"uint256[]"},{"name":"new_owner","type":"address"}],"name":"buyBulkPremiumCar","outputs":[{"name":"","type":"bool"}],"payable":true,"stateMutability":"payable","type":"function"},{"constant":false,"inputs":[{"name":"referal","type":"address"},{"name":"variants","type":"uint256[]"},{"name":"new_owner","type":"address"}],"name":"buyBulkRegularCar","outputs":[{"name":"","type":"bool"}],"payable":true,"stateMutability":"payable","type":"function"},{"constant":false,"inputs":[{"name":"referal","type":"address"},{"name":"cType","type":"uint256"},{"name":"give_refund","type":"bool"},{"name":"new_owner","type":"address"},{"name":"category","type":"uint256"}],"name":"buyCar","outputs":[{"name":"","type":"bool"}],"payable":true,"stateMutability":"payable","type":"function"},{"constant":false,"inputs":[],"name":"destroy","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_recipient","type":"address"}],"name":"destroyAndSend","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"category","type":"uint256"}],"name":"openShop","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"anonymous":false,"inputs":[{"indexed":true,"name":"previousOwner","type":"address"}],"name":"OwnershipRenounced","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"amount","type":"uint256"}],"name":"Withdrawal","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"carId","type":"uint256"},{"indexed":false,"name":"value","type":"uint256"},{"indexed":false,"name":"purchaser","type":"address"},{"indexed":false,"name":"category","type":"uint256"}],"name":"CarBought","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"variants","type":"uint256[]"},{"indexed":false,"name":"reserver","type":"address"},{"indexed":false,"name":"category","type":"uint256"}],"name":"consumerBulkBuy","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"previousOwner","type":"address"},{"indexed":true,"name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"cTypes","type":"uint256[]"},{"name":"category","type":"uint256"}],"name":"reserveManyTokens","outputs":[{"name":"","type":"bool"}],"payable":true,"stateMutability":"payable","type":"function"},{"constant":false,"inputs":[{"name":"referral","type":"address"},{"name":"percent","type":"uint256"}],"name":"setCommission","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"increase","type":"uint256"},{"name":"base","type":"uint256"},{"name":"cType","type":"uint256"}],"name":"setPercentIncrease","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"cType","type":"uint256"},{"name":"price","type":"uint256"}],"name":"setTypePrice","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"amount","type":"uint256"}],"name":"withdraw","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"inputs":[{"name":"tokenAddress","type":"address"},{"name":"tokenFactory","type":"address"},{"name":"e","type":"address"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"payable":true,"stateMutability":"payable","type":"fallback"},{"constant":true,"inputs":[],"name":"COMMISSION_PERCENT","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"}],"name":"currentTypePrice","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"GAS_REQUIREMENT","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"MAX_MIDGRADE","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"MAX_PREMIUM","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"MAX_REGULAR","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"MID_GRADE_CATEGORY","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"MIDGRADE_TYPE_COUNT","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"},{"name":"","type":"uint256"}],"name":"midGradeCarsBought","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"midGradeHold","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"midgradeOpen","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"PREMIUM_CATEGORY","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"PREMIUM_TYPE_COUNT","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"},{"name":"","type":"uint256"}],"name":"premiumCarsBought","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"premiumHold","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"premiumOpen","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"cType","type":"uint256"}],"name":"priceFor","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"REGULAR_CATEGORY","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"REGULAR_TYPE_COUNT","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"},{"name":"","type":"uint256"}],"name":"regularCarsBought","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"regularHold","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"regularOpen","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_tokenId","type":"uint256"}],"name":"sold","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"token","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"}],"name":"tokenReserve","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"}],
    preorder_batch: [{"constant":false,"inputs":[{"name":"referal","type":"address"},{"name":"variants","type":"uint256[]"},{"name":"new_owner","type":"address"}],"name":"buyBulkMidGradeCar","outputs":[{"name":"","type":"bool"}],"payable":true,"stateMutability":"payable","type":"function"},{"constant":true,"inputs":[],"name":"midgradeOpen","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"MIDGRADE_TYPE_COUNT","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"regularOpen","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"regularHold","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"premiumOpen","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"amount","type":"uint256"}],"name":"withdraw","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"MAX_REGULAR","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"referral","type":"address"},{"name":"percent","type":"uint256"}],"name":"setCommission","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"MID_GRADE_CATEGORY","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"MAX_MIDGRADE","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"GAS_REQUIREMENT","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"MAX_PREMIUM","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"referal","type":"address"},{"name":"variants","type":"uint256[]"},{"name":"new_owner","type":"address"}],"name":"buyBulkPremiumCar","outputs":[{"name":"","type":"bool"}],"payable":true,"stateMutability":"payable","type":"function"},{"constant":true,"inputs":[],"name":"REGULAR_TYPE_COUNT","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"PREMIUM_CATEGORY","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"destroy","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"cType","type":"uint256"},{"name":"price","type":"uint256"}],"name":"setTypePrice","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"cType","type":"uint256"}],"name":"priceFor","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"isOwner","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"BUFFER","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"}],"name":"tokenReserve","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"},{"name":"","type":"uint256"}],"name":"regularCarsBought","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_tokenId","type":"uint256"}],"name":"sold","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"COMMISSION_PERCENT","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"referal","type":"address"},{"name":"cType","type":"uint256"},{"name":"give_refund","type":"bool"},{"name":"new_owner","type":"address"},{"name":"category","type":"uint256"}],"name":"buyCar","outputs":[{"name":"","type":"bool"}],"payable":true,"stateMutability":"payable","type":"function"},{"constant":true,"inputs":[],"name":"premiumHold","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"},{"name":"","type":"uint256"}],"name":"premiumCarsBought","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"midGradeHold","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"REGULAR_CATEGORY","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"},{"name":"","type":"uint256"}],"name":"midGradeCarsBought","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"cTypes","type":"uint256[]"},{"name":"category","type":"uint256"},{"name":"referral","type":"address"}],"name":"reserveManyTokens","outputs":[{"name":"","type":"bool"}],"payable":true,"stateMutability":"payable","type":"function"},{"constant":true,"inputs":[],"name":"PREMIUM_TYPE_COUNT","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"}],"name":"currentTypePrice","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"category","type":"uint256"}],"name":"openShop","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"increase","type":"uint256"},{"name":"base","type":"uint256"},{"name":"cType","type":"uint256"}],"name":"setPercentIncrease","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_recipient","type":"address"}],"name":"destroyAndSend","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"token","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"referal","type":"address"},{"name":"variants","type":"uint256[]"},{"name":"new_owner","type":"address"}],"name":"buyBulkRegularCar","outputs":[{"name":"","type":"bool"}],"payable":true,"stateMutability":"payable","type":"function"},{"inputs":[{"name":"tokenAddress","type":"address"},{"name":"tokenFactory","type":"address"},{"name":"e","type":"address"},{"name":"preorder","type":"address"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"payable":true,"stateMutability":"payable","type":"fallback"},{"anonymous":false,"inputs":[{"indexed":false,"name":"variants","type":"uint256[]"},{"indexed":false,"name":"reserver","type":"address"},{"indexed":false,"name":"category","type":"uint256"},{"indexed":false,"name":"referral","type":"address"}],"name":"consumerBulkBuy","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"carId","type":"uint256"},{"indexed":false,"name":"value","type":"uint256"},{"indexed":false,"name":"purchaser","type":"address"},{"indexed":false,"name":"category","type":"uint256"}],"name":"CarBought","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"amount","type":"uint256"}],"name":"Withdrawal","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"previousOwner","type":"address"}],"name":"OwnershipRenounced","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"previousOwner","type":"address"},{"indexed":true,"name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"}],
    oldBzn:
    [ { "constant": true, "inputs": [], "name": "name", "outputs": [ { "name": "", "type": "string" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [ { "name": "_spender", "type": "address" }, { "name": "_value", "type": "uint256" } ], "name": "approve", "outputs": [ { "name": "", "type": "bool" } ], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "totalSupply", "outputs": [ { "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [ { "name": "_from", "type": "address" }, { "name": "_to", "type": "address" }, { "name": "_value", "type": "uint256" } ], "name": "transferFrom", "outputs": [ { "name": "", "type": "bool" } ], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "ADVISOR_POOL_INIT", "outputs": [ { "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "INITIAL_SUPPLY", "outputs": [ { "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "decimals", "outputs": [ { "name": "", "type": "uint8" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [ { "name": "_value", "type": "uint256" } ], "name": "burn", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "AdvisorPoolAddress", "outputs": [ { "name": "", "type": "address" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [ { "name": "_spender", "type": "address" }, { "name": "_subtractedValue", "type": "uint256" } ], "name": "decreaseApproval", "outputs": [ { "name": "", "type": "bool" } ], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "GAME_POOL_INIT", "outputs": [ { "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "name": "_owner", "type": "address" } ], "name": "balanceOf", "outputs": [ { "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [ { "name": "_from", "type": "address" }, { "name": "_value", "type": "uint256" } ], "name": "burnFrom", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "symbol", "outputs": [ { "name": "", "type": "string" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "INIT_COIN", "outputs": [ { "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [ { "name": "_to", "type": "address" }, { "name": "_value", "type": "uint256" } ], "name": "transfer", "outputs": [ { "name": "", "type": "bool" } ], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "name": "_spender", "type": "address" }, { "name": "_addedValue", "type": "uint256" } ], "name": "increaseApproval", "outputs": [ { "name": "", "type": "bool" } ], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "GamePoolAddress", "outputs": [ { "name": "", "type": "address" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "name": "_owner", "type": "address" }, { "name": "_spender", "type": "address" } ], "name": "allowance", "outputs": [ { "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "TEAM_POOL_INIT", "outputs": [ { "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "TeamPoolAddress", "outputs": [ { "name": "", "type": "address" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "inputs": [ { "name": "gamePool", "type": "address" }, { "name": "teamPool", "type": "address" }, { "name": "advisorPool", "type": "address" } ], "payable": false, "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [ { "indexed": true, "name": "burner", "type": "address" }, { "indexed": false, "name": "value", "type": "uint256" } ], "name": "Burn", "type": "event" }, { "anonymous": false, "inputs": [ { "indexed": true, "name": "owner", "type": "address" }, { "indexed": true, "name": "spender", "type": "address" }, { "indexed": false, "name": "value", "type": "uint256" } ], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [ { "indexed": true, "name": "from", "type": "address" }, { "indexed": true, "name": "to", "type": "address" }, { "indexed": false, "name": "value", "type": "uint256" } ], "name": "Transfer", "type": "event" } ],
    gamePool: [{"constant":false,"inputs":[{"name":"newToken","type":"address"}],"name":"setToken","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"_preorderFill","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"FILL_LIMIT","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"}],"name":"BZNclaimed","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"getFrom","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"initialize","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"balance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"contractName","type":"string"},{"name":"migrationId","type":"string"}],"name":"isMigrated","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"tokenAdr","type":"address"},{"name":"carAdr","type":"address"},{"name":"factory","type":"address"}],"name":"initialize","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_sender","type":"address"}],"name":"initialize","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"carToken","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"token","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"anonymous":false,"inputs":[{"indexed":true,"name":"user","type":"address"},{"indexed":true,"name":"_tokenId","type":"uint256"},{"indexed":false,"name":"amount","type":"uint256"}],"name":"Redeem","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"previousOwner","type":"address"},{"indexed":true,"name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"contractName","type":"string"},{"indexed":false,"name":"migrationId","type":"string"}],"name":"Migrated","type":"event"}],
    old2Bzn: [{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_value","type":"uint256"}],"name":"burn","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"AdvisorPoolAddress","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"account","type":"address"}],"name":"migrateAll","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_subtractedValue","type":"uint256"}],"name":"decreaseApproval","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"}],"name":"balanceOf","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_value","type":"uint256"}],"name":"burnFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"account","type":"address"},{"name":"amount","type":"uint256"}],"name":"migrate","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_addedValue","type":"uint256"}],"name":"increaseApproval","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"GamePoolAddress","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"TeamPoolAddress","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"inputs":[{"name":"gamePool","type":"address"},{"name":"teamPool","type":"address"},{"name":"advisorPool","type":"address"},{"name":"oldBzn","type":"address"},{"name":"oldTeamPool","type":"address"},{"name":"oldAdvisorPool","type":"address"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"amount","type":"uint256"}],"name":"Mint","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"burner","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Burn","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"owner","type":"address"},{"indexed":true,"name":"spender","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":false,"inputs":[{"name":"spender","type":"address"},{"name":"tokens","type":"uint256"},{"name":"data","type":"bytes"}],"name":"approveAndCall","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"}],
    bzn: [{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_value","type":"uint256"}],"name":"burn","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"AdvisorPoolAddress","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"account","type":"address"}],"name":"migrateAll","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_subtractedValue","type":"uint256"}],"name":"decreaseApproval","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"}],"name":"balanceOf","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_value","type":"uint256"}],"name":"burnFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"from","type":"address"},{"name":"tokens","type":"uint256"},{"name":"token","type":"address"},{"name":"data","type":"bytes"}],"name":"receiveApproval","outputs":[{"name":"","type":"bool"}],"payable":true,"stateMutability":"payable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"spender","type":"address"},{"name":"tokens","type":"uint256"},{"name":"data","type":"bytes"}],"name":"approveAndCall","outputs":[{"name":"success","type":"bool"}],"payable":true,"stateMutability":"payable","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_addedValue","type":"uint256"}],"name":"increaseApproval","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"GamePoolAddress","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"token","type":"address"},{"name":"account","type":"address"},{"name":"amount","type":"uint256"}],"name":"migrate","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"TeamPoolAddress","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"token","type":"address"},{"name":"account","type":"address"}],"name":"migrateAll","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"inputs":[{"name":"gamePool","type":"address"},{"name":"teamPool","type":"address"},{"name":"advisorPool","type":"address"},{"name":"oldTeamPool","type":"address"},{"name":"oldAdvisorPool","type":"address"},{"name":"oldBzn","type":"address[]"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"amount","type":"uint256"}],"name":"Mint","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"burner","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Burn","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"owner","type":"address"},{"indexed":true,"name":"spender","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"}],
    //bzn: [{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_value","type":"uint256"}],"name":"burn","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"AdvisorPoolAddress","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_subtractedValue","type":"uint256"}],"name":"decreaseApproval","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"}],"name":"balanceOf","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_value","type":"uint256"}],"name":"burnFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"from","type":"address"},{"name":"tokens","type":"uint256"},{"name":"token","type":"address"},{"name":"data","type":"bytes"}],"name":"receiveApproval","outputs":[{"name":"","type":"bool"}],"payable":true,"stateMutability":"payable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"spender","type":"address"},{"name":"tokens","type":"uint256"},{"name":"data","type":"bytes"}],"name":"approveAndCall","outputs":[{"name":"success","type":"bool"}],"payable":true,"stateMutability":"payable","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_addedValue","type":"uint256"}],"name":"increaseApproval","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"GamePoolAddress","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"token","type":"address"},{"name":"account","type":"address"},{"name":"amount","type":"uint256"}],"name":"migrate","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"TeamPoolAddress","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"token","type":"address"},{"name":"account","type":"address"}],"name":"migrateAll","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"inputs":[{"name":"gamePool","type":"address"},{"name":"teamPool","type":"address"},{"name":"advisorPool","type":"address"},{"name":"oldTeamPool","type":"address"},{"name":"oldAdvisorPool","type":"address"},{"name":"oldBzn","type":"address[]"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"amount","type":"uint256"}],"name":"Mint","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"burner","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Burn","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"owner","type":"address"},{"indexed":true,"name":"spender","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"}],
    gunFactory: [{"constant":false,"inputs":[{"internalType":"address","name":"dst","type":"address"}],"name":"attachPreOrder","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"dst","type":"address"}],"name":"attachToken","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"},{"internalType":"uint16","name":"size","type":"uint16"},{"internalType":"uint8","name":"category","type":"uint8"}],"name":"mintFor","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint8","name":"category","type":"uint8"},{"internalType":"uint256","name":"firstLimit","type":"uint256"},{"internalType":"uint256","name":"secondLimit","type":"uint256"},{"internalType":"uint256","name":"thirdLimit","type":"uint256"}],"name":"setCategoryLimit","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"constant":true,"inputs":[{"internalType":"uint8","name":"category","type":"uint8"}],"name":"currentLimit","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"isOwner","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"MIDGRADE_CATEGORY","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"mintedGuns","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"ONE_MONTH","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"PREMIUM_CATEGORY","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint8","name":"category","type":"uint8"}],"name":"reachedLimit","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"REGULAR_CATEGORY","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"}],
    gunToken: [{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"batchIndex","type":"uint256"}],"name":"BatchTransfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"allBatches","outputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint16","name":"size","type":"uint16"},{"internalType":"uint8","name":"category","type":"uint8"},{"internalType":"uint256","name":"startId","type":"uint256"},{"internalType":"uint256","name":"startTokenId","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"allTokens","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"__owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"batchIndex","type":"uint256"},{"internalType":"address","name":"to","type":"address"}],"name":"batchTransfer","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"batchesOwned","outputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint16","name":"size","type":"uint16"},{"internalType":"uint8","name":"category","type":"uint8"},{"internalType":"uint256","name":"startId","type":"uint256"},{"internalType":"uint256","name":"startTokenId","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"categoryForToken","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"categoryIdForToken","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint8","name":"category","type":"uint8"},{"internalType":"uint256","name":"categoryId","type":"uint256"}],"name":"categoryTypeToId","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint16","name":"size","type":"uint16"},{"internalType":"uint8","name":"category","type":"uint8"}],"name":"claimAllocation","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"_tokenId","type":"uint256"}],"name":"exists","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"__owner","type":"address"}],"name":"fallbackCount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"__owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"fallbackIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"__owner","type":"address"}],"name":"getBatchCount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getBatchIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"pure","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"__owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"getTokensInBatch","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint8","name":"category","type":"uint8"}],"name":"gunCountForCategory","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"factoryAddress","type":"address"},{"internalType":"address","name":"oldGunToken","type":"address"}],"name":"initialize","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"initialize","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"__owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"isOwner","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"lastAllocation","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"maxAllocation","outputs":[{"internalType":"uint16","name":"","type":"uint16"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"count","type":"uint256"}],"name":"migrate","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"pure","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"outOfBatch","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"ownedBatchIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"pure","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"__owner","type":"address"}],"name":"tokenOfOwner","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"__owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenOfOwnerByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"new_factory","type":"address"}],"name":"updateGunFactory","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}],
    gunPreOrder: [{"constant":false,"inputs":[{"internalType":"address","name":"referal","type":"address"},{"internalType":"uint8","name":"category","type":"uint8"},{"internalType":"address payable","name":"new_owner","type":"address"},{"internalType":"uint16","name":"quanity","type":"uint16"}],"name":"buyWithBZN","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":true,"stateMutability":"payable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"referal","type":"address"},{"internalType":"uint8","name":"category","type":"uint8"},{"internalType":"address","name":"new_owner","type":"address"},{"internalType":"uint16","name":"quanity","type":"uint16"}],"name":"buyWithEther","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":true,"stateMutability":"payable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint8","name":"category","type":"uint8"}],"name":"createCategory","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"disableCreateCategories","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint8","name":"category","type":"uint8"}],"name":"killCategory","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"uint256","name":"tokenAmount","type":"uint256"},{"internalType":"address","name":"tokenContract","type":"address"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"receiveApproval","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":true,"stateMutability":"payable","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"new_bzn_feed","type":"address"}],"name":"setBZNFeedContract","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"referral","type":"address"},{"internalType":"uint256","name":"percent","type":"uint256"}],"name":"setCommission","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"percent","type":"uint256"},{"internalType":"uint256","name":"base","type":"uint256"},{"internalType":"uint8","name":"category","type":"uint8"}],"name":"setEtherPercent","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"increase","type":"uint256"},{"internalType":"uint256","name":"base","type":"uint256"},{"internalType":"uint8","name":"category","type":"uint8"}],"name":"setPercentIncrease","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint8","name":"category","type":"uint8"},{"internalType":"uint256","name":"price","type":"uint256"},{"internalType":"bool","name":"inWei","type":"bool"}],"name":"setPrice","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint8","name":"category","type":"uint8"},{"internalType":"bool","name":"open","type":"bool"}],"name":"setShopState","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"withdraw","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"tokenAddress","type":"address"},{"internalType":"address","name":"tokenFactory","type":"address"},{"internalType":"address","name":"gp","type":"address"},{"internalType":"address","name":"isd","type":"address"},{"internalType":"address","name":"bzn_address","type":"address"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint8","name":"category","type":"uint8"},{"indexed":false,"internalType":"uint256","name":"quanity","type":"uint256"},{"indexed":false,"internalType":"address","name":"reserver","type":"address"}],"name":"consumerBulkBuy","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"gunId","type":"uint256"},{"indexed":false,"internalType":"address","name":"owner","type":"address"},{"indexed":false,"internalType":"uint8","name":"category","type":"uint8"}],"name":"GunsBought","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Withdrawal","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"constant":true,"inputs":[],"name":"allowCreateCategory","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"bznFeed","outputs":[{"internalType":"contract BZNFeed","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint8","name":"","type":"uint8"}],"name":"categoryExists","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint8","name":"","type":"uint8"}],"name":"categoryKilled","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint8","name":"","type":"uint8"}],"name":"categoryOpen","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint8","name":"","type":"uint8"}],"name":"categoryPercentBase","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint8","name":"","type":"uint8"}],"name":"categoryPercentIncrease","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint8","name":"","type":"uint8"}],"name":"categoryPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint8","name":"","type":"uint8"},{"internalType":"address","name":"","type":"address"}],"name":"categoryReserveAmount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"COMMISSION_PERCENT","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"usdValue","type":"uint256"},{"internalType":"bool","name":"isBZN","type":"bool"}],"name":"convert","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"ethFeed","outputs":[{"internalType":"contract IDSValue","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"isOwner","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint8","name":"category","type":"uint8"},{"internalType":"uint16","name":"quanity","type":"uint16"}],"name":"priceFor","outputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint8","name":"","type":"uint8"}],"name":"requiredEtherPercent","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint8","name":"","type":"uint8"}],"name":"requiredEtherPercentBase","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"_tokenId","type":"uint256"}],"name":"sold","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"token","outputs":[{"internalType":"contract GunToken","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"}],
    gameBalance: [{"inputs":[{"internalType":"address","name":"_link","type":"address"},{"internalType":"address","name":"_gamepool","type":"address"},{"internalType":"address","name":"_oracle","type":"address"},{"internalType":"address","name":"_bzn","type":"address"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"bytes32","name":"id","type":"bytes32"}],"name":"ChainlinkCancelled","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"bytes32","name":"id","type":"bytes32"}],"name":"ChainlinkFulfilled","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"bytes32","name":"id","type":"bytes32"}],"name":"ChainlinkRequested","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"from","type":"address"},{"indexed":false,"internalType":"string","name":"username","type":"string"},{"indexed":false,"internalType":"uint256","name":"bznAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"ethAmount","type":"uint256"}],"name":"depositEvent","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"linked","type":"address"},{"indexed":false,"internalType":"string","name":"username","type":"string"},{"indexed":false,"internalType":"uint256","name":"bznAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"ethAmount","type":"uint256"}],"name":"withdrawEvent","type":"event"},{"constant":false,"inputs":[{"internalType":"bytes","name":"data","type":"bytes"}],"name":"batchWithdraw","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"name":"bznHoldings","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"depositBZNLimit","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"depositETHLimit","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"name":"ethHoldings","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"bytes32","name":"_requestId","type":"bytes32"},{"internalType":"uint256","name":"_address","type":"uint256"}],"name":"fulfillUsername","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"gamePool","outputs":[{"internalType":"contract GamePoolInterface","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"gasRequirement","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"name":"hashToUser","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"isOwner","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"uint256","name":"tokens","type":"uint256"},{"internalType":"address","name":"token","type":"address"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"receiveApproval","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":true,"stateMutability":"payable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"gas","type":"uint256"}],"name":"setGasRequirement","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address payable","name":"user","type":"address"}],"name":"setGasUser","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"bznDeposit","type":"uint256"},{"internalType":"uint256","name":"bznWithdraw","type":"uint256"},{"internalType":"uint256","name":"ethDeposit","type":"uint256"},{"internalType":"uint256","name":"ethWithdraw","type":"uint256"}],"name":"setLimits","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"string","name":"s","type":"string"}],"name":"stringToUint","outputs":[{"internalType":"uint256","name":"result","type":"uint256"}],"payable":false,"stateMutability":"pure","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"string","name":"username","type":"string"}],"name":"usernameAsHash","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"payable":false,"stateMutability":"pure","type":"function"},{"constant":true,"inputs":[],"name":"usernameJobId","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"withdraw","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"withdrawlBZNLimit","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"withdrawlETHLimit","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"}],
    //bznStaking: [{"inputs":[{"components":[{"components":[{"internalType":"uint256","name":"minimum","type":"uint256"},{"internalType":"uint256","name":"maximum","type":"uint256"},{"internalType":"address","name":"uniswapRouter","type":"address"},{"internalType":"address","name":"bznAddress","type":"address"},{"internalType":"uint256","name":"bznSoftLimit","type":"uint256"},{"internalType":"uint256","name":"bznHardLimit","type":"uint256"},{"internalType":"uint256","name":"bznRatio","type":"uint256"},{"internalType":"address","name":"bznSource","type":"address"},{"internalType":"address payable","name":"recipient","type":"address"},{"components":[{"internalType":"uint256","name":"duration","type":"uint256"},{"internalType":"bool","name":"isLinear","type":"bool"},{"internalType":"uint256","name":"totalRewardAmount","type":"uint256"}],"internalType":"struct stakingConfig","name":"staking","type":"tuple"},{"internalType":"uint256","name":"dueDate","type":"uint256"},{"internalType":"uint256","name":"startDate","type":"uint256"}],"internalType":"struct LiquidityLockData","name":"data","type":"tuple"},{"components":[{"internalType":"bool","name":"isValid","type":"bool"},{"internalType":"uint32","name":"cliffDuration","type":"uint32"},{"internalType":"uint32","name":"duration","type":"uint32"},{"internalType":"uint32","name":"interval","type":"uint32"}],"internalType":"struct vestingSchedule","name":"schedule","type":"tuple"}],"internalType":"struct LiquidityLockConfig","name":"_config","type":"tuple"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Deposit","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"string","name":"reason","type":"string"}],"name":"Disabled","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"bznPrice","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"weiTotal","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"lpTokenTotal","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"bznExtra","type":"uint256"}],"name":"Locked","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":true,"internalType":"address","name":"token","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"RedeemedToken","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"reward","type":"uint256"}],"name":"RewardPaid","type":"event"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"_bznTokenGrants","outputs":[{"internalType":"bool","name":"isActive","type":"bool"},{"internalType":"uint32","name":"startDay","type":"uint32"},{"internalType":"uint256","name":"amount","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"_lastClaimTime","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"_lpTokenGrants","outputs":[{"internalType":"bool","name":"isActive","type":"bool"},{"internalType":"uint32","name":"startDay","type":"uint32"},{"internalType":"uint256","name":"amount","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_tokenStakingSchedule","outputs":[{"internalType":"bool","name":"isActive","type":"bool"},{"internalType":"uint256","name":"startTime","type":"uint256"},{"internalType":"uint256","name":"endTime","type":"uint256"},{"internalType":"uint256","name":"duration","type":"uint256"},{"internalType":"uint256","name":"rewardAmount","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_tokenVestingSchedule","outputs":[{"internalType":"bool","name":"isValid","type":"bool"},{"internalType":"uint32","name":"cliffDuration","type":"uint32"},{"internalType":"uint32","name":"duration","type":"uint32"},{"internalType":"uint32","name":"interval","type":"uint32"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"amountClaimed","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"amounts","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"claimFor","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"config","outputs":[{"internalType":"uint256","name":"minimum","type":"uint256"},{"internalType":"uint256","name":"maximum","type":"uint256"},{"internalType":"address","name":"uniswapRouter","type":"address"},{"internalType":"address","name":"bznAddress","type":"address"},{"internalType":"uint256","name":"bznSoftLimit","type":"uint256"},{"internalType":"uint256","name":"bznHardLimit","type":"uint256"},{"internalType":"uint256","name":"bznRatio","type":"uint256"},{"internalType":"address","name":"bznSource","type":"address"},{"internalType":"address payable","name":"recipient","type":"address"},{"components":[{"internalType":"uint256","name":"duration","type":"uint256"},{"internalType":"bool","name":"isLinear","type":"bool"},{"internalType":"uint256","name":"totalRewardAmount","type":"uint256"}],"internalType":"struct stakingConfig","name":"staking","type":"tuple"},{"internalType":"uint256","name":"dueDate","type":"uint256"},{"internalType":"uint256","name":"startDate","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"deposit","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"disabled","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"execute","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"executed","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"executedDay","outputs":[{"internalType":"uint32","name":"","type":"uint32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"executedTimestamp","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"grantHolder","type":"address"},{"internalType":"uint32","name":"onDay","type":"uint32"}],"name":"getAvailableBZNAmount","outputs":[{"internalType":"uint256","name":"amountAvailable","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"grantHolder","type":"address"},{"internalType":"uint32","name":"onDay","type":"uint32"}],"name":"getAvailableLPAmount","outputs":[{"internalType":"uint256","name":"amountAvailable","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"pairAddress","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getTokenPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"isDisabled","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"redeemExtraBZN","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"redeemLPTokens","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"reason","type":"string"}],"name":"refund","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address payable","name":"user","type":"address"}],"name":"refundWithdrawal","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"refundingEthAmount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"rewardAmountFor","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address payable","name":"depositor","type":"address"}],"name":"setup","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"stakingOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"today","outputs":[{"internalType":"uint32","name":"dayNumber","type":"uint32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalAmountDeposited","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalExtraBznAmount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalLiquidityAmount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalRewardPool","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalRewardsClaimed","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalStaking","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"userData","outputs":[{"internalType":"bool","name":"isActive","type":"bool"},{"internalType":"address","name":"user","type":"address"},{"internalType":"uint256","name":"lockStartTime","type":"uint256"},{"internalType":"uint256","name":"lpTokenTotal","type":"uint256"},{"internalType":"uint256","name":"bznExtraTotal","type":"uint256"}],"stateMutability":"view","type":"function"},{"stateMutability":"payable","type":"receive"}],
    bznPoolToken: [{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"},{"indexed":true,"internalType":"address","name":"to","type":"address"}],"name":"Burn","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"}],"name":"Mint","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0In","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1In","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount0Out","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1Out","type":"uint256"},{"indexed":true,"internalType":"address","name":"to","type":"address"}],"name":"Swap","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint112","name":"reserve0","type":"uint112"},{"indexed":false,"internalType":"uint112","name":"reserve1","type":"uint112"}],"name":"Sync","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[],"name":"DOMAIN_SEPARATOR","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"MINIMUM_LIQUIDITY","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"PERMIT_TYPEHASH","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"burn","outputs":[{"internalType":"uint256","name":"amount0","type":"uint256"},{"internalType":"uint256","name":"amount1","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"factory","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"getReserves","outputs":[{"internalType":"uint112","name":"_reserve0","type":"uint112"},{"internalType":"uint112","name":"_reserve1","type":"uint112"},{"internalType":"uint32","name":"_blockTimestampLast","type":"uint32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"_token0","type":"address"},{"internalType":"address","name":"_token1","type":"address"}],"name":"initialize","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"kLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"mint","outputs":[{"internalType":"uint256","name":"liquidity","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"nonces","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"permit","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"price0CumulativeLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"price1CumulativeLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"skim","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount0Out","type":"uint256"},{"internalType":"uint256","name":"amount1Out","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"swap","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"sync","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"token0","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"token1","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"}],
    garagePreOrder: [{"inputs":[{"internalType":"address","name":"tokenAddress","type":"address"},{"internalType":"address","name":"tokenFactory","type":"address"},{"internalType":"address","name":"gp","type":"address"},{"internalType":"address","name":"bzn_address","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"garageId","type":"uint256"},{"indexed":false,"internalType":"address","name":"owner","type":"address"},{"indexed":false,"internalType":"uint16","name":"category","type":"uint16"}],"name":"GaragesBought","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Withdrawal","type":"event"},{"inputs":[],"name":"COMMISSION_PERCENT","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"allowCreateCategory","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"referal","type":"address"},{"internalType":"uint16","name":"category","type":"uint16"},{"internalType":"address payable","name":"new_owner","type":"address"},{"internalType":"uint16","name":"quanity","type":"uint16"}],"name":"buyWithBZN","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint16","name":"","type":"uint16"}],"name":"categoryData","outputs":[{"internalType":"enum GaragePreOrder.CategoryState","name":"state","type":"uint8"},{"internalType":"uint256","name":"percentIncrease","type":"uint256"},{"internalType":"uint256","name":"percentBase","type":"uint256"},{"internalType":"uint256","name":"mintingFee","type":"uint256"},{"internalType":"uint256","name":"categoryPrice","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint16","name":"category","type":"uint16"}],"name":"categoryExists","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint16","name":"category","type":"uint16"}],"name":"createCategory","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"disableCreateCategories","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint16","name":"category","type":"uint16"}],"name":"killCategory","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint16","name":"category","type":"uint16"},{"internalType":"uint16","name":"quanity","type":"uint16"}],"name":"priceFor","outputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"address","name":"tokenContract","type":"address"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"receiveApproval","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"referral","type":"address"},{"internalType":"uint256","name":"percent","type":"uint256"}],"name":"setCommission","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint16","name":"category","type":"uint16"},{"internalType":"uint256","name":"fee","type":"uint256"}],"name":"setMintingFee","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"increase","type":"uint256"},{"internalType":"uint256","name":"base","type":"uint256"},{"internalType":"uint16","name":"category","type":"uint16"}],"name":"setPercentIncrease","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint16","name":"category","type":"uint16"},{"internalType":"uint256","name":"price","type":"uint256"},{"internalType":"bool","name":"inWei","type":"bool"}],"name":"setPrice","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint16","name":"category","type":"uint16"},{"internalType":"bool","name":"open","type":"bool"}],"name":"setShopState","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_tokenId","type":"uint256"}],"name":"sold","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"token","outputs":[{"internalType":"contract GarageToken","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"withdraw","outputs":[],"stateMutability":"nonpayable","type":"function"}],
    garageToken: [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[{"internalType":"address","name":"operator","type":"address"}],"name":"OperatorNotAllowed","type":"error"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"previousAdmin","type":"address"},{"indexed":false,"internalType":"address","name":"newAdmin","type":"address"}],"name":"AdminChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"beacon","type":"address"}],"name":"BeaconUpgraded","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint8","name":"version","type":"uint8"}],"name":"Initialized","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"implementation","type":"address"}],"name":"Upgraded","type":"event"},{"inputs":[],"name":"__DefaultOperatorFilterer_init","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"subscriptionOrRegistrantToCopy","type":"address"},{"internalType":"bool","name":"subscribe","type":"bool"}],"name":"__OperatorFilterer_init","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"allTokens","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint16","name":"","type":"uint16"}],"name":"categoryCount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"categoryForToken","outputs":[{"internalType":"uint16","name":"","type":"uint16"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint16","name":"","type":"uint16"}],"name":"categoryOffset","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint16","name":"category","type":"uint16"},{"internalType":"uint256","name":"categoryId","type":"uint256"}],"name":"categoryTypeToId","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"exists","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"factory","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_factory","type":"address"}],"name":"initialize","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"size","type":"uint256"},{"internalType":"uint16","name":"category","type":"uint16"}],"name":"mintFor","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"proxiableUUID","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"tokenIdToCategoryId","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenOfOwnerByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"tokensOfOwner","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newImplementation","type":"address"}],"name":"upgradeTo","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newImplementation","type":"address"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"upgradeToAndCall","outputs":[],"stateMutability":"payable","type":"function"}],
    garageFactory: [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"inputs":[],"name":"ONE_DAY","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"dst","type":"address"}],"name":"attachPreOrder","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"dst","type":"address"}],"name":"attachToken","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint16","name":"","type":"uint16"}],"name":"categoryData","outputs":[{"internalType":"uint256","name":"totalGaragesMinted","type":"uint256"},{"internalType":"uint256","name":"totalLimit","type":"uint256"},{"internalType":"uint256","name":"dailyLimit","type":"uint256"},{"internalType":"uint256","name":"currentDayEnd","type":"uint256"},{"internalType":"uint256","name":"currentDayTotal","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint16","name":"category","type":"uint16"}],"name":"hasReachedDailyLimit","outputs":[{"internalType":"bool","name":"","type":"bool"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"},{"internalType":"uint16","name":"size","type":"uint16"},{"internalType":"uint16","name":"category","type":"uint16"}],"name":"mintFor","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"mintedGarages","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint16","name":"category","type":"uint16"},{"internalType":"uint256","name":"categoryLimit","type":"uint256"}],"name":"setCategoryLimit","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}],
}

//factory 0x991058c585d82d3b6ec485efd331171c1f3c03a9
//rinkeby factory 0xf6aad170f25e46998a936199871066f9bb0d27ca
var contract_addressees = {
  car_tkn: '0x5caebd3b32e210e85ce3e9d51638b9c445481567',
  preorder: '0xe272fddbd056240149c771f9fd917fa040dceb39',
  car_token_factory: '0xe6963576E14aAD7743ef627B1ADa417Fc4C8d321',
  bzn: '0x6524b87960c2d573ae514fd4181777e7842435d4',
  old2Bzn: '0x85171d9cd1cfd8b10072096763674392176f039b',
  preorder_migrate: '0x243b8b0ac0571cfd300050c227091828202ff7bb',
  preorder_batch: '0xd558f0c903ccac458495f0dc776dbcc78f1adf79',
  gamePool: '0x83f11770176d959b19f9cc6e2d5a051cb101bdaf',
  oldBzn: '0x1BD223e638aEb3A943b8F617335E04f3e6B6fFfa',
  //TODO Change
  gunPreOrder: '0x691B35b35E18ad7d0E0CbB97059d2CDA0a457c36',
  //gunPreOrder: '0xE1ecFf44e00Da83C1BcA98e58Ccd5E0DeDeeb972',
  gunToken: '0x2D6e10561B320C4F31a903bF0FA92a1Ed58637C0',
  gunFactory: '0xFAC59958237AE5A5aa5075f944435899B8777922',
  //gunFactory: '0x0e8c6F144e0327F4FfC38277B2Fd8C5A7C5476e3',
  gameBalance: '0x6830252CBFA4233961702dE60D0872BCB6fEeEA8',
  //bznStaking: '0x7433A9Cd098c5a72F2Dc472D374d1798a137F713',
  bznPoolToken: '',
  garagePreOrder: '0x77e3d98Cb436abc8836107913dfA0EE7eAbE4a58',
  garageToken: '0xF991405E647ec2Ad874e6FdF645DDfa8Ad9Ad227',
  garageFactory: '0xC2939164C96C2375a571477298b00873b84f0C8A',
}

if (CONTRACTDEBUG) {
  contract_addressees = {
    car_tkn: '0x12d211ab84a43026b4bc51367193fe975871459d',
    preorder: '0x5122fefd1fc4052437485a9159e7ba6aa9f544e0',
    bzn: '0x8F54971B2e385FF8136aE7EbA5224274fB0ef9C5',
    old2Bzn: '0x9C7F67fdD92b6eC989cCCa4134977664c8B1a9d0', //INVALID
    preorder_batch: '0xd558f0c903ccac458495f0dc776dbcc78f1adf79', //INVALID
    preorder_migrate: '0xb60c9e29dfbca98e07a9cc04927e8a4f79039d25',
    car_token_factory: '0xe6963576E14aAD7743ef627B1ADa417Fc4C8d321', //INVALID
    //gamePool: '0x52aa11f1c31ef14a2d89b8c5e2d254e6ab8b0274',
    gamePool: '0x1e17708F66E63b53279b146870Ff557131F4a64e',
    oldBzn: '0x9C7F67fdD92b6eC989cCCa4134977664c8B1a9d0',
    gunPreOrder: '0x208e3FDB13BFF767b99Cd25ECEDb9727C2c24da8',
    gunToken: '0xbdD024541BB428F4a2bBcF18073304300039A7Ef',
    gunFactory: '0x62ED067862D579E4Fbd7F4dE97Ed4Ec329E838fF',
    gameBalance: "0x54d98ba9Ab92e00988a95B329931edE7258D95b5",
    //bznStaking: '0x02E35C88711DAfaee6163D751Be72a5385BB3647',
    bznPoolToken: '0x3b7e0093bD57415272f49332B27023C8f34D364B',
    garagePreOrder: '0x1154881C0B061204f72e230643c178268d88Fc5d',
    garageToken: '0xf99b1C9e3111958AB74F798AeFb963f56B3aD9Aa',
    garageFactory: '0x912c5aD6115D8BfdAaD492600B9f56C6968ddCF5',
  }
}

function setupContracts() {
  let car_token_contract = new variables.web3.eth.Contract(contract_abis.car_tkn, contract_addressees.car_tkn);
  let preorder_contract = new variables.web3.eth.Contract(contract_abis.preorder, contract_addressees.preorder);
  let car_factory_contract = new variables.web3.eth.Contract(contract_abis.car_token_factory, contract_addressees.car_token_factory);
  let bzn_contract = new variables.web3.eth.Contract(contract_abis.bzn, contract_addressees.bzn);
  let old2_bzn_contract = new variables.web3.eth.Contract(contract_abis.old2Bzn, contract_addressees.old2Bzn);
  let old_bzn_contract = new variables.web3.eth.Contract(contract_abis.oldBzn, contract_addressees.oldBzn);
  let preorder_migrate_contract = new variables.web3.eth.Contract(contract_abis.preorder, contract_addressees.preorder_migrate);
  let preorder_batch_contract = new variables.web3.eth.Contract(contract_abis.preorder_batch, contract_addressees.preorder_batch);
  let gamepool_contract = new variables.web3.eth.Contract(contract_abis.gamePool, contract_addressees.gamePool);

  let gun_token_contract = new variables.web3.eth.Contract(contract_abis.gunToken, contract_addressees.gunToken);
  let gun_preorder_contract = new variables.web3.eth.Contract(contract_abis.gunPreOrder, contract_addressees.gunPreOrder);
  let gun_factory_contract = new variables.web3.eth.Contract(contract_abis.gunFactory, contract_addressees.gunFactory);
  let game_balance_contract = new variables.web3.eth.Contract(contract_abis.gameBalance, contract_addressees.gameBalance);
  //let bzn_staking_contract = new variables.web3.eth.Contract(contract_abis.bznStaking, contract_addressees.bznStaking);
  let bzn_pool_contract = new variables.web3.eth.Contract(contract_abis.bznPoolToken, contract_addressees.bznPoolToken);
  let garage_preorder_contract = new variables.web3.eth.Contract(contract_abis.garagePreOrder, contract_addressees.garagePreOrder);
  let garage_token_contract = new variables.web3.eth.Contract(contract_abis.garageToken, contract_addressees.garageToken);
  let garage_factory_contract = new variables.web3.eth.Contract(contract_abis.garageFactory, contract_addressees.garageFactory);
  let contracts = {
    carToken: car_token_contract,
    preorder: preorder_contract,
    carTokenFactory: car_factory_contract,
    preorder_migrate: preorder_migrate_contract,
    preorder_batch: preorder_batch_contract,
    bzn: bzn_contract,
    old2Bzn: old2_bzn_contract,
    oldBzn: old_bzn_contract,
    gamePool: gamepool_contract,
    gunToken: gun_token_contract,
    gunPreOrder: gun_preorder_contract,
    gunFactory: gun_factory_contract,
    gameBalance: game_balance_contract,
    //bznStaking: bzn_staking_contract,
    bznPool: bzn_pool_contract,
    garagePreOrder: garage_preorder_contract,
    garageToken: garage_token_contract,
    garageFactory: garage_factory_contract,
  };
  variables.contracts = contracts;

  let info_car_token_contract = new variables.infoWeb3.eth.Contract(contract_abis.car_tkn, contract_addressees.car_tkn);
  let info_preorder_contract = new variables.infoWeb3.eth.Contract(contract_abis.preorder, contract_addressees.preorder);
  let info_car_factory_contract = new variables.web3.eth.Contract(contract_abis.car_token_factory, contract_addressees.car_token_factory);
  let info_preorder_migrate_contract = new variables.infoWeb3.eth.Contract(contract_abis.preorder, contract_addressees.preorder_migrate);
  let info_bzn_contract = new variables.infoWeb3.eth.Contract(contract_abis.bzn, contract_addressees.bzn);
  let info_old2_bzn_contract = new variables.infoWeb3.eth.Contract(contract_abis.old2Bzn, contract_addressees.old2Bzn);
  let info_old_bzn_contract = new variables.infoWeb3.eth.Contract(contract_abis.oldBzn, contract_addressees.oldBzn);
  let info_gamepool_contract = new variables.infoWeb3.eth.Contract(contract_abis.gamePool, contract_addressees.gamePool);

  let info_gun_token_contract = new variables.infoWeb3.eth.Contract(contract_abis.gunToken, contract_addressees.gunToken);
  let info_gun_preorder_contract = new variables.infoWeb3.eth.Contract(contract_abis.gunPreOrder, contract_addressees.gunPreOrder);
  let info_gun_factory_contract = new variables.infoWeb3.eth.Contract(contract_abis.gunFactory, contract_addressees.gunFactory);
  let info_game_balance_contract = new variables.infoWeb3.eth.Contract(contract_abis.gameBalance, contract_addressees.gameBalance);
  //let info_bzn_staking_contract = new variables.infoWeb3.eth.Contract(contract_abis.bznStaking, contract_addressees.bznStaking);
  let info_bzn_pool_contract = new variables.infoWeb3.eth.Contract(contract_abis.bznPoolToken, contract_addressees.bznPoolToken);
  let info_garage_preorder_contract = new variables.infoWeb3.eth.Contract(contract_abis.garagePreOrder, contract_addressees.garagePreOrder);
  let info_garage_token_contract = new variables.infoWeb3.eth.Contract(contract_abis.garageToken, contract_addressees.garageToken);
  let info_garage_factory_contract = new variables.infoWeb3.eth.Contract(contract_abis.garageFactory, contract_addressees.garageFactory);
  let info_contracts = {
    carToken: info_car_token_contract,
    preorder: info_preorder_contract,
    carTokenFactory: info_car_factory_contract,
    preorder_migrate: info_preorder_migrate_contract,
    bzn: info_bzn_contract,
    old2Bzn: info_old2_bzn_contract,
    oldBzn: info_old_bzn_contract,
    gamePool: info_gamepool_contract,
    gunToken: info_gun_token_contract,
    gunPreOrder: info_gun_preorder_contract,
    gunFactory: info_gun_factory_contract,
    gameBalance: info_game_balance_contract,
    //bznStaking: info_bzn_staking_contract,
    bznPool: info_bzn_pool_contract,
    garagePreOrder: info_garage_preorder_contract,
    garageToken: info_garage_token_contract,
    garageFactory: info_garage_factory_contract,
  };

  variables.infoContracts = info_contracts;

  const provider = variables.eweb3.getSigner ? variables.eweb3.getSigner() : variables.eweb3;

  let ethers_car_token_contract = new ethers.Contract(contract_addressees.car_tkn, contract_abis.car_tkn, provider);
  let ethers_preorder_contract = new ethers.Contract(contract_addressees.preorder, contract_abis.preorder, provider);
  let ethers_car_factory_contract = new ethers.Contract(contract_addressees.car_token_factory, contract_abis.car_token_factory, provider);
  let ethers_bzn_contract = new ethers.Contract(contract_addressees.bzn, contract_abis.bzn, provider);
  let ethers_old2_bzn_contract = new ethers.Contract(contract_addressees.old2Bzn, contract_abis.old2Bzn, provider);
  let ethers_old_bzn_contract = new ethers.Contract(contract_addressees.oldBzn, contract_abis.oldBzn, provider);
  let ethers_preorder_migrate_contract = new ethers.Contract(contract_addressees.preorder_migrate, contract_abis.preorder, provider);
  let ethers_preorder_batch_contract = new ethers.Contract(contract_addressees.preorder_batch, contract_abis.preorder_batch, provider);
  let ethers_gamepool_contract = new ethers.Contract(contract_addressees.gamePool, contract_abis.gamePool, provider);

  let ethers_gun_token_contract = new ethers.Contract(contract_addressees.gunToken, contract_abis.gunToken, provider);
  let ethers_gun_preorder_contract = new ethers.Contract(contract_addressees.gunPreOrder, contract_abis.gunPreOrder, provider);
  let ethers_gun_factory_contract = new ethers.Contract(contract_addressees.gunFactory, contract_abis.gunFactory, provider);
  let ethers_game_balance_contract = new ethers.Contract(contract_addressees.gameBalance, contract_abis.gameBalance, provider);
  //let ethers_bzn_staking_contract = new ethers.Contract(contract_addressees.bznStaking, contract_abis.bznStaking, provider);
  let ethers_bzn_pool_contract = new ethers.Contract(contract_addressees.bznPoolToken, contract_abis.bznPoolToken, provider);
  let ethers_garage_preorder_contract = new ethers.Contract(contract_addressees.garagePreOrder, contract_abis.garagePreOrder, provider);
  let ethers_garage_token_contract = new ethers.Contract(contract_addressees.garageToken, contract_abis.garageToken, provider);
  let ethers_garage_factory_contract = new ethers.Contract(contract_addressees.garageFactory, contract_abis.garageFactory, provider);
  let ether_contracts = {
    carToken: ethers_car_token_contract,
    preorder: ethers_preorder_contract,
    carTokenFactory: ethers_car_factory_contract,
    preorder_migrate: ethers_preorder_migrate_contract,
    preorder_batch: ethers_preorder_batch_contract,
    bzn: ethers_bzn_contract,
    old2Bzn: ethers_old2_bzn_contract,
    oldBzn: ethers_old_bzn_contract,
    gamePool: ethers_gamepool_contract,
    gunToken: ethers_gun_token_contract,
    gunPreOrder: ethers_gun_preorder_contract,
    gunFactory: ethers_gun_factory_contract,
    gameBalance: ethers_game_balance_contract,
    //bznStaking: ethers_bzn_staking_contract,
    bznPool: ethers_bzn_pool_contract,
    garagePreOrder: ethers_garage_preorder_contract,
    garageToken: ethers_garage_token_contract,
    garageFactory: ethers_garage_factory_contract,
  };
  variables.econtracts = ether_contracts;
}

function toStr(x) {
  return (JSON.stringify(x))
}



var cars = {
  premium: [
    {
      name: 'SUV Kit',
      img: imgs.suv,
      data: [{name: 'Speed', value: 500},
              {name: 'Armor Units', value: 150},
              {name: 'Benzene Tank', value: 170},
              {name: 'Main Gun Slots', value: 4}]
    },
    {
      name: 'tanker Kit',
      img: imgs.suv,
      data: [{name: 'Speed', value: 380},
              {name: 'Armor Units', value: 350},
              {name: 'Benzene Tank', value: 330},
              {name: 'Main Gun Slots', value: 5}]
    },
    {
      name: 'war lambo Kit',
      img: imgs.lambo,
      data: [{name: 'Speed', value: 610},
              {name: 'Armor Units', value: 150},
              {name: 'Benzene Tank', value: 150},
              {name: 'Main Gun Slots', value: 2}]
    },
  ],
  midGrade: [
    {
      name: 'lambo Kit',
      img: imgs.lambo,
      data: [{name: 'Speed', value: 300},
              {name: 'Armor Units', value: 150},
              {name: 'Benzene Tank', value: 100},
              {name: 'Main Gun Slots', value: 4}]
    },
    {
      name: 'tanker Kit',
      img: imgs.suv,
      data: [{name: 'Speed', value: 100},
            {name: 'Armor Units', value: 100},
            {name: 'Benzene Tank', value: 100},
            {name: 'Main Gun Slots', value: 4}]
    },
    {
      name: 'other Kit',
      img: imgs.suv,
      data: [{name: 'Speed', value: 100},
            {name: 'Armor Units', value: 100},
            {name: 'Benzene Tank', value: 100},
            {name: 'Main Gun Slots', value: 4}]
    },
  ],
  regular: [
    {
      name: 'lambo Kit',
      img: imgs.lambo,
      data: [{name: 'Speed', value: 100},
            {name: 'Armor Units', value: 100},
            {name: 'Benzene Tank', value: 100},
            {name: 'Main Gun Slots', value: 4}]
    },
    {
      name: 'tanker Kit',
      img: imgs.suv,
      data: [{name: 'Speed', value: 100},
            {name: 'Armor Units', value: 100},
            {name: 'Benzene Tank', value: 100},
            {name: 'Main Gun Slots', value: 4}]
    },
    {
      name: 'other Kit',
      img: imgs.suv,
      data: [{name: 'Speed', value: 100},
            {name: 'Armor Units', value: 100},
            {name: 'Benzene Tank', value: 100},
            {name: 'Main Gun Slots', value: 4}]
    },
  ]
};
let indices = {
  speed: 1,
  acc: 2,
  armor: 3,
  bznTank: 4,
  engine: 5,
  mainGuns: 6,
  altGuns: 7,
  equipmentSlots: 8,
  nos: 9,
  rateOfFire: 10,
  velocity: 11,
  effectiveRange: 12,
  maxRange: 13
};
var cars_table_data = {
  premium: [
    {
      name: 'SUV Kit',
      img: imgs.suv,
      engine: 450,
      armor: 275,
      bznTank: 175,
      speed: 109.375,
      acc: 7,
      mainGuns: 2,
      altGuns: 1,
      equipmentSlots: 2,
      description: 'A nimble, robust BZN-gobbler that will get put any player at the top of their class'
    },
    {
      name: 'War Truck Kit',
      img: imgs.war_truck,
      engine: 875,
      armor: 775,
      bznTank: 375,
      speed: 62.5,
      acc: 3.36,
      mainGuns: 2,
      altGuns: 2,
      equipmentSlots: 3,
      description: 'A nimble, robust BZN-gobbler that will get put any player at the top of their class'
    },
    {
      name: 'Hovercraft Kit',
      img: imgs.hovercraft,
      engine: 1150,
      armor: 950,
      bznTank: 275,
      speed: 125,
      acc: 7,
      mainGuns: 2,
      altGuns: 3,
      equipmentSlots: 2,
      description: 'A nimble, robust BZN-gobbler that will get put any player at the top of their class'
    },
    {
      name: 'Car Tank Kit',
      img: imgs.tanker,
      engine: 1835,
      armor: 1775,
      bznTank: 175,
      speed: 37.5,
      acc: 1.92,
      mainGuns: 3,
      altGuns: 5,
      equipmentSlots: 5,
      description: 'A nimble, robust BZN-gobbler that will get put any player at the top of their class'
    },
    {
      name: 'War Lambo Kit',
      img: imgs.lambo,
      engine: 950,
      armor: 675,
      bznTank: 225,
      speed: 171.875,
      acc: 10.145,
      mainGuns: 1,
      altGuns: 2,
      equipmentSlots: 5,
      description: 'A nimble, robust BZN-gobbler that will get put any player at the top of their class'
    },
  ],
  midGrade: [
    {
      name: 'Dune Buggy Kit',
      img: imgs.buggy,
      engine: 400,
      armor: 250,
      bznTank: 95,
      speed: 93.75,
      acc: 6.04,
      mainGuns: 1,
      altGuns: 2,
      equipmentSlots: 1,
      description: 'A nimble, robust BZN-gobbler that will get put any player at the top of their class'
    }
  ],
  regular: [
    {
      name: 'Hatchback Kit',
      img: imgs.regular,
      engine: 330,
      armor: 220,
      bznTank: 70,
      speed: 68.75,
      acc: 4.36,
      mainGuns: 1,
      altGuns: 2,
      equipmentSlots: 1,
      description: 'A nimble, robust BZN-gobbler that will get put any player at the top of their class'
    }
  ]
};

var extra_lambos_idk = [
  {
    name: 'Glass War Lambo',
    img: imgs.glassLambo,
    engineMin: 900,
    engineMax: 1000,
    armorMin: 650,
    armorMax: 700,
    bznTankMin: 200,
    bznTankMax: 250,
    speedMin: 125,
    speedMax: 218.75,
    accMin: 7.03,
    accMax: 13.26,
    mainGuns: 1,
    altGuns: 2,
    totalGuns: '3',
    totalSpeed: '211.25',
    totalBznTank: '250',
    equipmentSlots: 5,
    description: 'The War Lambo is a speedy beast on customized sand-adapted suspension. War Lambos are the fastest and most stylish vehicles in the Wasteland, and each has the special ability of instantly gaining speed. There are only 100 Lambos​ to ever be released.',
    nos: true,
    base_price: 0.5000,
    totalSupply: 100,
    tokenId: "5912323901083942206"
  },
  {
    name: 'Glass Car Tank',
    img: imgs.glassTank,
    engineMin: 900,
    engineMax: 1000,
    armorMin: 650,
    armorMax: 700,
    bznTankMin: 200,
    bznTankMax: 250,
    speedMin: 125,
    speedMax: 218.75,
    accMin: 7.03,
    accMax: 13.26,
    mainGuns: 1,
    altGuns: 2,
    totalGuns: '8',
    totalSpeed: '55.0',
    totalBznTank: '200',
    equipmentSlots: 5,
    description: 'The War Lambo is a speedy beast on customized sand-adapted suspension. War Lambos are the fastest and most stylish vehicles in the Wasteland, and each has the special ability of instantly gaining speed. There are only 100 Lambos​ to ever be released.',
    nos: true,
    base_price: 0.5000,
    totalSupply: 100,
    tokenId: "9789600394704026216"
  },
  {
    name: 'Glass Hovercraft',
    img: imgs.glassHover,
    engineMin: 900,
    engineMax: 1000,
    armorMin: 650,
    armorMax: 700,
    bznTankMin: 200,
    bznTankMax: 250,
    speedMin: 125,
    speedMax: 218.75,
    accMin: 7.03,
    accMax: 13.26,
    mainGuns: 1,
    altGuns: 2,
    totalGuns: '5',
    totalSpeed: '180.0',
    totalBznTank: '300',
    equipmentSlots: 5,
    description: 'The War Lambo is a speedy beast on customized sand-adapted suspension. War Lambos are the fastest and most stylish vehicles in the Wasteland, and each has the special ability of instantly gaining speed. There are only 100 Lambos​ to ever be released.',
    nos: true,
    base_price: 0.5000,
    totalSupply: 100,
    tokenId: "8068014255768252592"
  },
  {
    name: 'Gold War Lambo',
    img: imgs.goldLambo,
    engineMin: 900,
    engineMax: 1000,
    armorMin: 650,
    armorMax: 700,
    bznTankMin: 200,
    bznTankMax: 250,
    speedMin: 125,
    speedMax: 218.75,
    accMin: 7.03,
    accMax: 13.26,
    mainGuns: 1,
    altGuns: 2,
    totalGuns: '3',
    totalSpeed: '212.5',
    totalBznTank: '250',
    equipmentSlots: 5,
    description: 'The War Lambo is a speedy beast on customized sand-adapted suspension. War Lambos are the fastest and most stylish vehicles in the Wasteland, and each has the special ability of instantly gaining speed. There are only 100 Lambos​ to ever be released.',
    nos: true,
    base_price: 0.5000,
    totalSupply: 100,
    tokenId: "843221646648971129"
  },
  {
    name: 'Founders War Lambo',
    img: imgs.foundersLambo,
    engineMin: 900,
    engineMax: 1000,
    armorMin: 650,
    armorMax: 700,
    bznTankMin: 200,
    bznTankMax: 250,
    speedMin: 125,
    speedMax: 218.75,
    accMin: 7.03,
    accMax: 13.26,
    mainGuns: 1,
    altGuns: 2,
    totalGuns: '3',
    totalSpeed: '218.75',
    totalBznTank: '250',
    equipmentSlots: 5,
    description: 'The War Lambo is a speedy beast on customized sand-adapted suspension. War Lambos are the fastest and most stylish vehicles in the Wasteland, and each has the special ability of instantly gaining speed. There are only 100 Lambos​ to ever be released.',
    nos: true,
    base_price: 0.5000,
    totalSupply: 100,
    tokenId: "8604137203067332802"
  },
  {
    name: 'Platinum War Lambo',
    img: imgs.platinumLambo,
    engineMin: 900,
    engineMax: 1000,
    armorMin: 650,
    armorMax: 700,
    bznTankMin: 200,
    bznTankMax: 250,
    speedMin: 125,
    speedMax: 218.75,
    accMin: 7.03,
    accMax: 13.26,
    mainGuns: 1,
    altGuns: 2,
    totalGuns: '3',
    totalSpeed: '209.38',
    totalBznTank: '250',
    equipmentSlots: 5,
    description: 'The War Lambo is a speedy beast on customized sand-adapted suspension. War Lambos are the fastest and most stylish vehicles in the Wasteland, and each has the special ability of instantly gaining speed. There are only 100 Lambos​ to ever be released.',
    nos: true,
    base_price: 0.5000,
    totalSupply: 100,
    tokenId: "8704822909050111306"
  },
  {
    name: 'Gold Car Tank',
    img: imgs.goldTank,
    engineMin: 900,
    engineMax: 1000,
    armorMin: 650,
    armorMax: 700,
    bznTankMin: 200,
    bznTankMax: 250,
    speedMin: 125,
    speedMax: 218.75,
    accMin: 7.03,
    accMax: 13.26,
    mainGuns: 1,
    altGuns: 2,
    totalGuns: '8',
    totalSpeed: '56.25',
    totalBznTank: '200',
    equipmentSlots: 5,
    description: 'The War Lambo is a speedy beast on customized sand-adapted suspension. War Lambos are the fastest and most stylish vehicles in the Wasteland, and each has the special ability of instantly gaining speed. There are only 100 Lambos​ to ever be released.',
    nos: true,
    base_price: 0.5000,
    totalSupply: 100,
    tokenId: "9660260820660918852"
  },
  {
    name: 'Founders Car Tank',
    img: imgs.foundersTank,
    engineMin: 900,
    engineMax: 1000,
    armorMin: 650,
    armorMax: 700,
    bznTankMin: 200,
    bznTankMax: 250,
    speedMin: 125,
    speedMax: 218.75,
    accMin: 7.03,
    accMax: 13.26,
    mainGuns: 1,
    altGuns: 2,
    totalGuns: '8',
    totalSpeed: '62.5',
    totalBznTank: '200',
    equipmentSlots: 5,
    description: 'The War Lambo is a speedy beast on customized sand-adapted suspension. War Lambos are the fastest and most stylish vehicles in the Wasteland, and each has the special ability of instantly gaining speed. There are only 100 Lambos​ to ever be released.',
    nos: true,
    base_price: 0.5000,
    totalSupply: 100,
    tokenId: "9723696158936285040"
  },
  {
    name: 'Platinum Car Tank',
    img: imgs.platinumTank,
    engineMin: 900,
    engineMax: 1000,
    armorMin: 650,
    armorMax: 700,
    bznTankMin: 200,
    bznTankMax: 250,
    speedMin: 125,
    speedMax: 218.75,
    accMin: 7.03,
    accMax: 13.26,
    mainGuns: 1,
    altGuns: 2,
    totalGuns: '8',
    totalSpeed: '53.13',
    totalBznTank: '200',
    equipmentSlots: 5,
    description: 'The War Lambo is a speedy beast on customized sand-adapted suspension. War Lambos are the fastest and most stylish vehicles in the Wasteland, and each has the special ability of instantly gaining speed. There are only 100 Lambos​ to ever be released.',
    nos: true,
    base_price: 0.5000,
    totalSupply: 100,
    tokenId: "9762733553971739821"
  }
];

var cars_table_data_minMax = {
  premium: [
    {
      name: 'SUV Kit',
      img: imgs.suv,
      type: "SUV",
      typeIndex: 1,
      engineMin: 400,
      engineMax: 500,
      armorMin: 250,
      armorMax: 300,
      bznTankMin: 150,
      bznTankMax: 200,
      speedMin: 62.5,
      speedMax: 156.25,
      accMin: 3.57,
      accMax: 10.42,
      mainGuns: 2,
      altGuns: 1,
      totalGuns: '1-3',
      totalSpeed: '62.5-156.25',
      totalBznTank: '150-200',
      equipmentSlots: 2,
      description: 'The SUVs are kings of the Wasteland. They have a good balance of speed, armor, and BZN tank space. The SUVs can be fast, deadly, and are perfect for guarding slower vehicles. There are only 20,000 SUVs to ever be released. ',
      nos: true,
      base_price: 0.0330,
      totalSupply: 20000
    },
    {
      name: 'War Truck Kit',
      img: imgs.war_truck,
      type: "Truck",
      typeIndex: 2,
      engineMin: 850,
      engineMax: 900,
      armorMin: 750,
      armorMax: 800,
      bznTankMin: 300,
      bznTankMax: 450,
      speedMin: 31.25,
      speedMax: 93.75,
      accMin: 1.61,
      accMax: 5.11,
      mainGuns: 2,
      altGuns: 2,
      totalGuns: '1-4',
      totalSpeed: '31.25-93.75',
      totalBznTank: '300-450',
      equipmentSlots: 3,
      description: 'The War Truck is a moving battle fortress with a huge BZN tank, but it is relatively slow. War Trucks can be used to carry large amounts of Benzene across the Wasteland, especially when paired with lighter “guarding” vehicles. There are only 9,000 War Trucks​ that will ever be released.',
      nos: true,
      base_price: 0.0560,
      totalSupply: 9000
    },
    {
      name: 'Hovercraft Kit',
      img: imgs.hovercraft,
      type: "Hovercraft",
      typeIndex: 3,
      engineMin: 1100,
      engineMax: 1200,
      armorMin: 900,
      armorMax: 1000,
      bznTankMin: 250,
      bznTankMax: 300,
      speedMin: 62.5,
      speedMax: 187.5,
      accMin: 3.27,
      accMax: 10.71,
      mainGuns: 2,
      altGuns: 3,
      totalGuns: '1-4',
      totalSpeed: '62.5-187.5',
      totalBznTank: '250-300',
      equipmentSlots: 2,
      description: 'The Hovercraft is a fast, maneuverable vehicle capable of instantaneous turns without loss of speed. Hovercrafts combine excellent defending capabilities with large BZN tanks and impressive acceleration performance. Only 600 Hovercrafts​ will ever be released. ',
      nos: true,
      base_price: 0.1000,
      totalSupply: 600
    },
    {
      name: 'Car Tank Kit',
      img: imgs.tanker,
      type: "Tank",
      typeIndex: 4,
      engineMin: 1820,
      engineMax: 1850,
      armorMin: 1750,
      armorMax: 1800,
      bznTankMin: 150,
      bznTankMax: 200,
      speedMin: 12.5,
      speedMax: 62.5,
      accMin: 0.63,
      accMax: 3.21,
      mainGuns: 3,
      altGuns: 5,
      totalGuns: '1-8',
      totalSpeed: '12.5-62.5',
      totalBznTank: '150-200',
      equipmentSlots: 5,
      description: 'The Car Tank is a stylish special vehicle with incredible armor and off roading tracks. Tanks are slow and have relatively small BZN tanks, but they don’t receive critical damage and have a lot of weaponry. There are only 300 Tanks that will ever be released.',
      nos: true,
      base_price: 0.1330,
      totalSupply: 300
    },
    {
      name: 'War Lambo Kit',
      img: imgs.lambo,
      type: "Lambo",
      typeIndex: 5,
      engineMin: 900,
      engineMax: 1000,
      armorMin: 650,
      armorMax: 700,
      bznTankMin: 200,
      bznTankMax: 250,
      speedMin: 125,
      speedMax: 218.75,
      accMin: 7.03,
      accMax: 13.26,
      mainGuns: 1,
      altGuns: 2,
      totalGuns: '1-3',
      totalSpeed: '125-218.75',
      totalBznTank: '200-250',
      equipmentSlots: 5,
      description: 'The War Lambo is a speedy beast on customized sand-adapted suspension. War Lambos are the fastest and most stylish vehicles in the Wasteland, and each has the special ability of instantly gaining speed. There are only 100 Lambos​ to ever be released.',
      nos: true,
      base_price: 0.5000,
      totalSupply: 100
    }
  ],
  midGrade: [
    {
      name: 'Dune Buggy Kit',
      img: imgs.buggy,
      type: "Buggy",
      typeIndex: 6,
      engineMin: 350,
      engineMax: 450,
      armorMin: 220,
      armorMax: 280,
      bznTankMin: 70,
      bznTankMax: 120,
      speedMin: 43.75,
      speedMax: 143.75,
      accMin: 2.43,
      accMax: 9.65,
      mainGuns: 1,
      altGuns: 2,
      totalGuns: '1-3',
      totalSpeed: '43.75-143.75',
      totalBznTank: '70-120',
      equipmentSlots: 1,
      description: 'Dune Buggies are designed for experienced players interested in a good balance of price and power. Excellent maneuverability, impressive speed characteristics, and 3 gun slots make an excellent Benzene hunter. Only 40,000 Dune Buggies will ever be released.',
      nos: false,
      base_price: 0.0330,
      totalSupply: 40000
    },
    {
      name: 'War EV Kit',
      img: evCar,
      type: "War EV",
      typeIndex: 7,
      engineMin: 320,
      engineMax: 390,
      armorMin: 190,
      armorMax: 250,
      bznTankMin: 60,
      bznTankMax: 110,
      speedMin: 37.50,
      speedMax: 137.50,
      accMin: 2.07,
      accMax: 9.24,
      mainGuns: 1,
      altGuns: 2,
      totalGuns: '1-3',
      totalSpeed: '37.50-137.50',
      totalBznTank: '60-110',
      equipmentSlots: 1,
      description: 'The War EV is the first electric vehicle in the Wasteland. This killer machine is one of the fastest and most stylish mid-grade cars. Up to three weapons and decent BZN tank makes makes this luxury baby one of the most desired in the game.',
      nos: false,
      base_price: 0.0330,
      totalSupply: 50000
    },{
      name: 'Trophy Truck Kit',
      img: imgs.trophyTruck,
      type: "Trophy Truck",
      typeIndex: 8,
      engineMin: 300,
      engineMax: 390,
      armorMin: 190,
      armorMax: 250,
      bznTankMin: 50,
      bznTankMax: 100,
      speedMin: 31.25,
      speedMax: 125.00,
      accMin: 1.70,
      accMax: 8.41,
      mainGuns: 1,
      altGuns: 1,
      totalGuns: '1-2',
      totalSpeed: '31.25-125.00',
      totalBznTank: '50-100',
      equipmentSlots: 1,
      description: 'The Trophy Truck features a unique rear suspension with long tailing arms for better offroad handling.',
      nos: false,
      base_price: 0.0330,
      totalSupply: 60000
    }
  ],
  regular: [
    {
      name: 'Hatchback Kit',
      img: imgs.regular,
      type: "Hatchback",
      typeIndex: 9,
      acc: '1.35-7.37',
      engineMin: 280,
      engineMax: 380,
      armorMin: 200,
      armorMax: 240,
      bznTankMin: 50,
      bznTankMax: 90,
      speedMin: 25,
      speedMax: 112.5,
      accMin: 1.35,
      accMax: 7.37,
      mainGuns: 1,
      altGuns: 2,
      totalGuns: '1-3',
      totalSpeed: '25-112.5',
      totalBznTank: '50-90',
      equipmentSlots: 1,
      description: 'Hatchbacks are regular-grade vehicles representing an entry-level war machine for all types of players. They can be used for general purposes like Benzene mining, Wasteland patrol, and vehicular combat. There are only 200,000 Hatchbacks​ that will ever be released.',
      nos: false,
      base_price: 0.0330,
      totalSupply: 200000
    },{
      name: 'Unknown Kit',
      img: imgs.unknownVehicle,
      type: "Regular Type 2",
      typeIndex: 10,
      engineMin: 245,
      engineMax: 345,
      armorMin: 180,
      armorMax: 210,
      bznTankMin: 30,
      bznTankMax: 70,
      speedMin: 21.88,
      speedMax: 103.13,
      accMin: 1.18,
      accMax: 6.78,
      mainGuns: 1,
      altGuns: 2,
      totalGuns: '1-3',
      totalSpeed: '21.88-103.13',
      totalBznTank: '30-70',
      equipmentSlots: 1,
      description: 'Dune Buggies are designed for experienced players interested in a good balance of price and power. Excellent maneuverability, impressive speed characteristics, and 3 gun slots make an excellent Benzene hunter. Only 40,000 Dune Buggies will ever be released.',
      nos: false,
      base_price: 0.0330,
      totalSupply: 300000
    },{
      name: 'Unknown Kit',
      img: imgs.unknownVehicle,
      type: "Regular Type 3",
      typeIndex: 11,
      engineMin: 220,
      engineMax: 300,
      armorMin: 150,
      armorMax: 190,
      bznTankMin: 20,
      bznTankMax: 40,
      speedMin: 18.75,
      speedMax: 93.75,
      accMin: 1.01,
      accMax: 6.25,
      mainGuns: 1,
      altGuns: 1,
      totalGuns: '1-2',
      totalSpeed: '18.75-93.75',
      totalBznTank: '20-40',
      equipmentSlots: 1,
      description: 'Dune Buggies are designed for experienced players interested in a good balance of price and power. Excellent maneuverability, impressive speed characteristics, and 3 gun slots make an excellent Benzene hunter. Only 40,000 Dune Buggies will ever be released.',
      nos: false,
      base_price: 0.0330,
      totalSupply: 500000

    }
  ]
};
var cars_table_data_minDiff = {
  premium: [
    {
      name: 'SUV Kit',
      img: imgs.suv,
      engineMin: cars_table_data_minMax.premium[0].engineMin,
      engineDiff: cars_table_data_minMax.premium[0].engineMax-cars_table_data_minMax.premium[0].engineMin,
      armorMin: cars_table_data_minMax.premium[0].armorMin,
      armorDiff: cars_table_data_minMax.premium[0].engineMax-cars_table_data_minMax.premium[0].engineMin,
      bznTankMin: cars_table_data_minMax.premium[0].bznTankMin,
      bznTankDiff: cars_table_data_minMax.premium[0].bznTankMax-cars_table_data_minMax.premium[0].bznTankMin,
      speedMin: cars_table_data_minMax.premium[0].speedMin,
      speedDiff: cars_table_data_minMax.premium[0].speedMax-cars_table_data_minMax.premium[0].speedMin,
      accMin: cars_table_data_minMax.premium[0].accMin,
      accDiff: cars_table_data_minMax.premium[0].accMax-cars_table_data_minMax.premium[0].accMin,
      mainGuns: 2,
      altGuns: 1,
      totalGuns: '2-3',
      equipmentSlots: 2,
      description: cars_table_data_minMax.premium[0].description
    },
    {
      name: 'War Truck Kit',
      img: imgs.war_truck,
      engineMin: cars_table_data_minMax.premium[1].engineMin,
      engineDiff: cars_table_data_minMax.premium[1].engineMax-cars_table_data_minMax.premium[1].engineMin,
      armorMin: cars_table_data_minMax.premium[1].armorMin,
      armorDiff: cars_table_data_minMax.premium[1].engineMax-cars_table_data_minMax.premium[1].engineMin,
      bznTankMin: cars_table_data_minMax.premium[1].bznTankMin,
      bznTankDiff: cars_table_data_minMax.premium[1].bznTankMax-cars_table_data_minMax.premium[1].bznTankMin,
      speedMin: cars_table_data_minMax.premium[1].speedMin,
      speedDiff: cars_table_data_minMax.premium[1].speedMax-cars_table_data_minMax.premium[1].speedMin,
      accMin: cars_table_data_minMax.premium[1].accMin,
      accDiff: cars_table_data_minMax.premium[1].accMax-cars_table_data_minMax.premium[1].accMin,
      mainGuns: 2,
      altGuns: 2,
      totalGuns: '2-4',
      equipmentSlots: 3,
      description: cars_table_data_minMax.premium[1].description
    },
    {
      name: 'Hovercraft Kit',
      img: imgs.hovercraft,
      engineMin: cars_table_data_minMax.premium[2].engineMin,
      engineDiff: cars_table_data_minMax.premium[2].engineMax-cars_table_data_minMax.premium[2].engineMin,
      armorMin: cars_table_data_minMax.premium[2].armorMin,
      armorDiff: cars_table_data_minMax.premium[2].engineMax-cars_table_data_minMax.premium[2].engineMin,
      bznTankMin: cars_table_data_minMax.premium[2].bznTankMin,
      bznTankDiff: cars_table_data_minMax.premium[2].bznTankMax-cars_table_data_minMax.premium[2].bznTankMin,
      speedMin: cars_table_data_minMax.premium[2].speedMin,
      speedDiff: cars_table_data_minMax.premium[2].speedMax-cars_table_data_minMax.premium[2].speedMin,
      accMin: cars_table_data_minMax.premium[2].accMin,
      accDiff: cars_table_data_minMax.premium[2].accMax-cars_table_data_minMax.premium[2].accMin,
      mainGuns: 2,
      altGuns: 3,
      totalGuns: '2-4',
      equipmentSlots: 2,
      description: cars_table_data_minMax.premium[2].description
    },
    {
      name: 'Car Tank Kit',
      img: imgs.tanker,
      engineMin: cars_table_data_minMax.premium[3].engineMin,
      engineDiff: cars_table_data_minMax.premium[3].engineMax-cars_table_data_minMax.premium[3].engineMin,
      armorMin: cars_table_data_minMax.premium[3].armorMin,
      armorDiff: cars_table_data_minMax.premium[3].engineMax-cars_table_data_minMax.premium[3].engineMin,
      bznTankMin: cars_table_data_minMax.premium[3].bznTankMin,
      bznTankDiff: cars_table_data_minMax.premium[3].bznTankMax-cars_table_data_minMax.premium[3].bznTankMin,
      speedMin: cars_table_data_minMax.premium[3].speedMin,
      speedDiff: cars_table_data_minMax.premium[3].speedMax-cars_table_data_minMax.premium[3].speedMin,
      accMin: cars_table_data_minMax.premium[3].accMin,
      accDiff: cars_table_data_minMax.premium[3].accMax-cars_table_data_minMax.premium[3].accMin,
      mainGuns: 3,
      altGuns: 5,
      totalGuns: '3-8',
      equipmentSlots: 5,
      description: cars_table_data_minMax.premium[3].description
    },
    {
      name: 'War Lambo Kit',
      img: imgs.lambo,
      engineMin: cars_table_data_minMax.premium[4].engineMin,
      engineDiff: cars_table_data_minMax.premium[4].engineMax-cars_table_data_minMax.premium[4].engineMin,
      armorMin: cars_table_data_minMax.premium[4].armorMin,
      armorDiff: cars_table_data_minMax.premium[4].engineMax-cars_table_data_minMax.premium[4].engineMin,
      bznTankMin: cars_table_data_minMax.premium[4].bznTankMin,
      bznTankDiff: cars_table_data_minMax.premium[4].bznTankMax-cars_table_data_minMax.premium[4].bznTankMin,
      speedMin: cars_table_data_minMax.premium[4].speedMin,
      speedDiff: cars_table_data_minMax.premium[4].speedMax-cars_table_data_minMax.premium[4].speedMin,
      accMin: cars_table_data_minMax.premium[4].accMin,
      accDiff: cars_table_data_minMax.premium[4].accMax-cars_table_data_minMax.premium[4].accMin,
      mainGuns: 1,
      altGuns: 2,
      totalGuns: '1-3',
      equipmentSlots: 5,
      description: cars_table_data_minMax.premium[4].description
    },
  ],
  midGrade: [
    {
      name: 'Dune Buggy Kit',
      img: imgs.buggy,
      engineMin: cars_table_data_minMax.midGrade[0].engineMin,
      engineDiff: cars_table_data_minMax.midGrade[0].engineMax-cars_table_data_minMax.midGrade[0].engineMin,
      armorMin: cars_table_data_minMax.midGrade[0].armorMin,
      armorDiff: cars_table_data_minMax.midGrade[0].engineMax-cars_table_data_minMax.midGrade[0].engineMin,
      bznTankMin: cars_table_data_minMax.midGrade[0].bznTankMin,
      bznTankDiff: cars_table_data_minMax.midGrade[0].bznTankMax-cars_table_data_minMax.midGrade[0].bznTankMin,
      speedMin: cars_table_data_minMax.midGrade[0].speedMin,
      speedDiff: cars_table_data_minMax.midGrade[0].speedMax-cars_table_data_minMax.midGrade[0].speedMin,
      accMin: cars_table_data_minMax.midGrade[0].accMin,
      accDiff: cars_table_data_minMax.midGrade[0].accMax-cars_table_data_minMax.midGrade[0].accMin,
      mainGuns: 1,
      altGuns: 2,
      totalGuns: '1-3',
      equipmentSlots: 1,
      description: cars_table_data_minMax.midGrade[0].description
    }
  ],
  regular: [
    {
      name: 'Hatchback Kit',
      img: imgs.regular,
      engineMin: cars_table_data_minMax.regular[0].engineMin,
      engineDiff: cars_table_data_minMax.regular[0].engineMax-cars_table_data_minMax.regular[0].engineMin,
      armorMin: cars_table_data_minMax.regular[0].armorMin,
      armorDiff: cars_table_data_minMax.regular[0].engineMax-cars_table_data_minMax.regular[0].engineMin,
      bznTankMin: cars_table_data_minMax.regular[0].bznTankMin,
      bznTankDiff: cars_table_data_minMax.regular[0].bznTankMax-cars_table_data_minMax.regular[0].bznTankMin,
      speedMin: cars_table_data_minMax.regular[0].speedMin,
      speedDiff: cars_table_data_minMax.regular[0].speedMax-cars_table_data_minMax.regular[0].speedMin,
      accMin: cars_table_data_minMax.regular[0].accMin,
      accDiff: cars_table_data_minMax.regular[0].accMax-cars_table_data_minMax.regular[0].accMin,
      mainGuns: 1,
      altGuns: 2,
      totalGuns: '1-3',
      equipmentSlots: 1,
      description: cars_table_data_minMax.regular[0].description
    }
  ]
};

var sample_car_data = {
  premium: [
    {
      name: 'SUV Kit',
      img: imgs.suv,
      engine: 500,
      armor: 300,
      bznTank: 200,
      speed: 62.5,
      acc: 3.57,
      mainGuns: 1,
      altGuns: 1,
      equipmentSlots: 2,
      description: 'A nimble, robust BZN-gobbler that will get put any player at the top of their class',
      nos: true
    },
    {
      name: 'War Truck Kit',
      img: imgs.war_truck,
      engine: 500,
      armor: 300,
      bznTank: 200,
      speed: 62.5,
      acc: 3.57,
      mainGuns: 3,
      altGuns: 1,
      equipmentSlots: 2,
      description: 'A nimble, robust BZN-gobbler that will get put any player at the top of their class',
      nos: true
    },
    {
      name: 'Hovercraft Kit',
      img: imgs.hovercraft,
      engine: 500,
      armor: 300,
      bznTank: 200,
      speed: 62.5,
      acc: 3.57,
      mainGuns: 2,
      altGuns: 1,
      equipmentSlots: 2,
      description: 'A nimble, robust BZN-gobbler that will get put any player at the top of their class',
      nos: true
    },
    {
      name: 'Tank Kit',
      img: imgs.tanker,
      engine: 500,
      armor: 300,
      bznTank: 200,
      speed: 62.5,
      acc: 3.57,
      mainGuns: 2,
      altGuns: 1,
      equipmentSlots: 2,
      description: 'A nimble, robust BZN-gobbler that will get put any player at the top of their class',
      nos: true
    },
    {
      name: 'Lambo Kit',
      img: imgs.lambo,
      engine: 500,
      armor: 300,
      bznTank: 200,
      speed: 62.5,
      acc: 3.57,
      mainGuns: 2,
      altGuns: 1,
      equipmentSlots: 2,
      description: 'A nimble, robust BZN-gobbler that will get put any player at the top of their class',
      nos: true
    },
  ],
  midGrade: [
    {
      name: 'Dune Buggy Kit',
      img: imgs.buggy,
      engine: 500,
      armor: 300,
      bznTank: 200,
      speed: 62.5,
      acc: 3.57,
      mainGuns: 2,
      altGuns: 1,
      equipmentSlots: 2,
      description: 'A nimble, robust BZN-gobbler that will get put any player at the top of their class',
      nos: true
    }
  ],
  regular: [
    {
      name: 'Hatchback Kit',
      img: imgs.regular,
      engine: 500,
      armor: 300,
      bznTank: 200,
      speed: 62.5,
      acc: 3.57,
      mainGuns: 2,
      altGuns: 1,
      equipmentSlots: 2,
      description: 'A nimble, robust BZN-gobbler that will get put any player at the top of their class',
      nos: true
    }
  ]
};


var gradients = {
  minBar: 'linear-gradient(90deg, rgba(113,33,217,1) 0%, rgba(132,44,207,1) 35%, rgba(105,65,235,1) 100%)',
  maxBar: 'linear-gradient(90deg, rgba(59,30,159,1) 0%, rgba(86,29,253,1) 50%, rgba(69,17,186,1) 100%)'
};
//
// var ranges = {
//   premium: {
//     engineMin:
//     engineDiff: cars_table_data_minMax.premium[0].engineMax-cars_table_data_minMax.premium[0].engineMin,
//     armorMin: cars_table_data_minMax.premium[0].armorMin,
//     armorDiff: cars_table_data_minMax.premium[0].engineMax-cars_table_data_minMax.premium[0].engineMin,
//     bznTankMin: cars_table_data_minMax.premium[0].bznTankMin,
//     bznTankDiff: cars_table_data_minMax.premium[0].bznTankMax-cars_table_data_minMax.premium[0].bznTankMin,
//     speedMin: cars_table_data_minMax.premium[0].speedMin,
//     speedDiff: cars_table_data_minMax.premium[0].speedMax-cars_table_data_minMax.premium[0].speedMin,
//     accMin: cars_table_data_minMax.premium[0].accMin,
//     accDiff: cars_table_data_minMax.premium[0].accMax-cars_table_data_minMax.premium[0].accMin,
//   }
// }
  // Travel speed = (Engine power - Armor)/1.6
function calculateSpeed(engineSize, armor) {
  return ((engineSize - armor)/1.6);
}
  // Acceleration Ratio = Armor / Engine Power
  // Acceleration = (Travel speed/10) / (Acceleration Ratio + 1)
function calculateAcceleration(engineSize, armor) {
  var ratio = armor / engineSize;
  var speed = calculateSpeed(engineSize, armor);
  var acc = (speed/10) / (ratio + 1);
  return acc;
}

//var server_local = 'http://127.0.0.1:1234';
var server_local = 'https://api.warriders.com';
var URLs = {
  /*getCarData: function(type, car) {
      return (server_local + '/getCarData/' + type + '/' + car)
    },*/
  requestReferral: server_local + '/requestReferral',
  referredToByGenID: server_local + '/referredToByGenID',
  referredToByGenIOffline: server_local + '/referredToByGenIDOffline',
  getReferrer: server_local + '/getReferrer',
  selectType: '/selectType',
  selectGunType: '/selectGun',
  selectGarageType: '/selectGarage',
  deposit: '/deposit',
  garage: '/garage',
  leaderboard: '/leaderboard',
  extras: '/extras',
  linkAccount: '/link',
  migratebzn: '/migrate',
  viewAllGuns: '/garage/guns/-1',
  viewAllBatches: '/garage/guns/-2',
  viewAllGarageTitles: '/garage/garageList',
  lip: server_local + '/lsueipd',
  emailURL: server_local + '/subscribe',
  //stakingListURL: server_local + '/addresses/bznStaking',
  bundles: 'https://warriders.com/bundle-sale/',
  howto: 'https://warriders.com/how-to/',
  warpaper: 'https://warriders.com/wp/',
  getAvailableTokens: server_local + '/getAvailableTokens',
  bznmigratelearn: 'https://warriders.com/bzn-migration/',
  garageWithParams: function(type, car) {
      return ('/garage/' + type + '/' + car)
    },
    viewMyCar: function(type, car, token) {
        return ('/garage/' + token)
      },
  selectCar: function(typeIndex) {
      return ('/selectCar/' + typeIndex)
    },
    selectGun: function(typeIndex) {
        return ('/viewCase/' + typeIndex)
      },
      selectGarage: function(typeIndex) {
        return ('/garages/' + typeIndex)
      },
  viewCar: function(typeIndex, carIndex) {
      return ('/viewCar/' + typeIndex + '/' + carIndex)
    },
  viewAuction: function(id) {
    return ('/viewAuction/' + id)
  },
  viewMyGun: function(category, categoryId) {
    return ('/guns/' + category + '/' + categoryId)
  },
  viewMyGun: function(tokenId) {
    return ('/guns/' + tokenId);
  },
  viewMyGarage: function(category, categoryId) {
    return ('/garageTitle/' + category + '/' + categoryId);
  },
  viewMyGarage: function(tokenId) {
    return ('/garageTitle/' + tokenId);
  },
  viewBatch: function(batchNumber) {
    return ('/garage/guns/' + batchNumber);
  }
};

var info_maxes = {
  speed: 218.75,
  acc: 13.26,
  engine: 1850,
  bznTank: 450,
  armor: 1800,
  mainGunSlots: 3,
  altSlots: 5,
  equipmentSlots: 5,
  rateOfFire: 600,
  velocity: 985,
  effectiveRange: 776,
  maxRange: 3089,
  tokensPerNFT: 100,
  renewTerm: 100,
  entranceFee: 100,
  entrances: 20
};
function convertValue(index, value) {
  // Get value to 100 (standardize)
  var returning;
  var maxes = info_maxes;
  if (index == indices.speed) {
    let max = maxes.speed;
    let conversion = 100/max;
    returning = value * conversion;
  } else if (index === indices.acc) {
    let max = maxes.acc;
    let conversion = 100/max;
    returning = value * conversion;
  } else if (index === indices.armor) {
    let max = maxes.armor;
    let conversion = 100/max;
    returning = value * conversion;
  } else if (index === indices.bznTank) {
    let max = maxes.bznTank;
    let conversion = 100/max;
    returning = value * conversion;
  } else if (index === indices.engine) {
    let max = maxes.engine;
    let conversion = 100/max;
    returning = value * conversion;
  } else if (index === indices.mainGuns) {
    let max = maxes.mainGunSlots;
    let conversion = 100/max;
    returning = value * conversion;
  } else if (index === indices.altGuns) {
    let max = maxes.altSlots;
    let conversion = 100/max;
    returning = value * conversion;
  } else if (index === indices.equipmentSlots) {
    let max = maxes.equipmentSlots;
    let conversion = 100/max;
    returning = value * conversion;
  } else if (index == indices.nos) {
    if (value) { return 100; } else { return 0; }
  } else if (index == indices.rateOfFire) {
    let max = maxes.rateOfFire;
    let conversion = 100/max;
    returning = value * conversion;
  } else if (index == indices.velocity) {
    let max = maxes.velocity;
    let conversion = 100/max;
    returning = value * conversion;
  } else if (index == indices.effectiveRange) {
    let max = maxes.effectiveRange;
    let conversion = 100/max;
    returning = value * conversion;
  } else if (index == indices.maxRange) {
    let max = maxes.maxRange;
    let conversion = 100/max;
    returning = value * conversion;
  }
  return returning;
}

async function wait(ms) {
  return new Promise(resolve => {
    setTimeout(resolve, ms);
  });
}

function isFunction(functionToCheck) {
 return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}

function reallySetWeb3Provider(provider) {
  web3 = new Web3(provider);
  eweb3 = new ethers.providers.Web3Provider(provider);
  variables.web3 = web3;
  variables.eweb3 = eweb3;

  completeWeb3(true);
}

var variables = {
  isDebug: CONTRACTDEBUG,
  firebase: firebase,
  hideIt: false,
  contracts: null,
  abis: contract_abis,
  infoContracts: null,
  econtracts: null,
  cars: cars,
  cars_table_data: cars_table_data,
  cars_table_data_minDiff: cars_table_data_minDiff,
  cars_table_data_minMax: cars_table_data_minMax,
  extraLambos: extra_lambos_idk,
  sampleCars: sample_car_data,
  urls: URLs,
  maxes: info_maxes,
  web3: web3,
  eweb3: eweb3,
  infoWeb3: infoWeb3,
  web3Modal: web3Modal,
  etherscanApi: 'UF9IAYD4IHATIXQ3IAW1BMEJX3YSK83SZJ',
  setWeb3Provider: reallySetWeb3Provider,
  accountPendingLink: function() {
    return new Promise(function(resolve, reject) {
      let user = firebase.auth().currentUser;
      if (user == null) {
        resolve(false)
      }
      var userId = firebase.auth().currentUser.uid;

      firebase.database().ref("pendingaddress/" + userId).once('value').then(function(snapshot) {
        var address = snapshot.val() || "";

        if (address != "") {
          resolve(true)
        } else {
          resolve(false)
        }
      }).catch(function(e) {
        reject(e);
      })
    });
  },
  username: function() {
    return new Promise(function(resolve, reject) {
      let user = firebase.auth().currentUser;
      if (user == null) {
        reject("not-loggedin")
      } else {
        var userId = user.uid;

        firebase.database().ref("users/" + userId).once('value').then(function(snapshot) {
          var username = (snapshot.val() && snapshot.val().username) || "";
  
          if (username == "" || username == " ") {
            reject("not-linked");
          } else {
            resolve(username);
          }
        });
      }
    });
  },
  accountLinked: function() {
    return new Promise(function(resolve, reject) {
      let user = firebase.auth().currentUser;
      if (user == null) {
        reject("not-loggedin");
      }
      var userId = firebase.auth().currentUser.uid;

      firebase.database().ref("users/" + userId).once('value').then(function(snapshot) {
        var address = (snapshot.val() && snapshot.val().eth) || "";

        if (address == "" || address == " ") {
          reject("not-linked");
        } else {
          resolve(address);
        }
      });
    });
  },
  addWeb3DisconnectListener: function(callback) {
    disconnectCallbacks.push(callback);
  },
  web3Logout: disconnectWeb3,
  askForWeb3: function(){
    if (window.ethereum || window.web3) {
      return askForInjection();
    }
    else {
      return activateWeb3Modal()
    }
  },
  waitForWeb3: function() {
    return new Promise(async function(resolve, reject) {
      while (!isEnabled && !isLocked) {
        console.log("Waiting for web3..");
        await wait(500);
      }

      if (isEnabled) {
        resolve();
      }
      else {
        reject("Web3 access has either been denied or does not exist");
      }
    });
  },
/*   bznStakingAt: async function(address, executable) {
    console.log(server_local + `/validator/bznStakingAddress/${address}`)
    const approved = (await (await fetch(server_local + `/validator/bznStakingAddress/${address}`)).json()).valid;

    if (!approved) {
      throw new Error('Invalid URL');
    }

    if (executable) {
      const provider = this.eweb3.getSigner ? this.eweb3.getSigner() : this.eweb3;
      return new ethers.Contract(address, contract_abis.bznStaking, provider);
    } else {
      return new this.infoWeb3.eth.Contract(contract_abis.bznStaking, address);
    }
  }, */
  getAccounts: function(callback) {
      if (isFunction(callback)) {
        this.getAccounts().then(function(accounts) {
          callback(null, accounts);
        }).catch(function(error) {
          callback(error, null);
        });
        return;
      } else {
        let self = this;
        return new Promise(async function(resolve, reject) {
          try {
            await self.waitForWeb3();
            self.web3.eth.getAccounts((error, accounts) => {
              if (accounts != null ){
                if (accounts.length == 0) {
                    // there is no active accounts in MetaMask
                    reject('There are no accounts!')
                }
                else {
                  resolve(accounts);

                }
              }
              else {
                console.log("NO ACCOUNT ERROR: " + error);
                reject('NO ACCOUNTS')
              }

            })
          } catch (e) {
            reject(e);
          }
      })
    }
  },
  reconnectWeb3: function(Web3) {
    this.web3 = new Web3(Web3.givenProvider || Web3.currentProvider || new Web3.providers.HttpProvider("https://mainnet.infura.io/q9oDMrI6Ii1QzpKLZpio"));
  },
  isWeb3Known: function() {
    if (!isEnabled)
      return false;

    const { currentProvider: cp } = this.web3
    const isToshi = !!cp.isToshi;
    const isCipher = !!cp.isCipher;
    const isMetaMask = !!cp.isMetaMask;

    return isToshi || isCipher || isMetaMask || isEnabled;
  },
  gradients: gradients,
  getTokenIds: function(amount, type, car, amountBought, totalSupply) {
    let allTokenIds = TokensInfo.ids;
    let mutableStartIndex = amountBought;
    let endIndex = totalSupply;
    if (type==0) {
      let tokenIds = [];
      for (var i = 0; i < amount; i++) {
        var tokenId = allTokenIds.premium[car][mutableStartIndex];
        tokenIds.push(tokenId);
        mutableStartIndex += 1;
      }
      return tokenIds;
    } else if (type==1) {
      let tokenIds = [];
      for (var i = 0; i < amount; i++) {
        var tokenId = allTokenIds.midGrade[car][mutableStartIndex];
        tokenIds.push(tokenId);
        mutableStartIndex += 1;
      }
      return tokenIds;
    } else if (type==2) {
      let tokenIds = [];
      for (var i = 0; i < amount; i++) {
        var tokenId = allTokenIds.regular[car][mutableStartIndex];
        tokenIds.push(tokenId);
        mutableStartIndex += 1;
      }
      return tokenIds;
    }
  },
  getConvRanges: function(type) {
    if (type == 0) {
      var engineMin=-1,
      engineMax=-1,
      armorMin=-1,
      armorMax=-1,
      bznTankMin=-1,
      bznTankMax=-1,
      speedMin=-1,
      speedMax=-1,
      accMin=-1,
      accMax=-1;
      var t = cars_table_data_minMax.premium.map(function(car) {
        if (engineMax != -1 && car.engineMax > engineMax) {
          engineMax = car.engineMax;
        } else if (engineMax == -1) {
          engineMax = car.engineMax;
        }
        if (engineMin != -1 && car.engineMin < engineMin) {
          engineMin = car.engineMin;
        } else if (engineMin == -1) {
          engineMin = car.engineMin;
        }
        if (armorMax != -1 && car.armorMax > armorMax) {
          armorMax = car.armorMax;
        } else if (armorMax == -1) {
          armorMax = car.armorMax;
        }

        if (armorMin != -1 && car.armorMin < armorMin) {
          armorMin = car.armorMin;
        } else if (armorMin == -1) {
          armorMin = car.armorMin;
        }

        if (bznTankMin != -1 && car.bznTankMin < bznTankMin) {
          bznTankMin = car.bznTankMin;
        } else if (bznTankMin == -1) {
          bznTankMin = car.bznTankMin;
        }

        if (bznTankMax != -1 && car.bznTankMax > bznTankMax) {
          bznTankMax = car.bznTankMax;
        } else if (bznTankMax == -1) {
          bznTankMax = car.bznTankMax;
        }

        if (speedMin != -1 && car.speedMin < speedMin) {
          speedMin = car.speedMin;
        } else if (speedMin == -1) {
          speedMin = car.speedMin;
        }

        if (speedMax != -1 && car.speedMax > speedMax) {
          speedMax = car.speedMax;
        } else if (speedMax == -1) {
          speedMax = car.speedMax;
        }

        if (accMin != -1 && car.accMin < accMin) {
          accMin = car.accMin;
        } else if (accMin == -1) {
          accMin = car.accMin;
        }

        if (accMax != -1 && car.accMax > accMax) {
          accMax = car.accMax;
        } else if (accMax == -1) {
          accMax = car.accMax;
        }

      });

      let indices = {
        speed: 1,
        acc: 2,
        armor: 3,
        bznTank: 4,
        engine: 5,
        mainGuns: 6,
        altGuns: 7,
        equipmentSlots: 8,
        nos: 9,
        rateOfFire: 10,
        velocity: 11,
        effectiveRange: 12,
        maxRange: 13
      };

      var convertedJson = [ {name: 'Engine', min: roundToTwo(convertValue(5,engineMin)), max: roundToTwo(convertValue(5,engineMax))}, {name: 'Armor', min: roundToTwo(convertValue(3,armorMin)), max: roundToTwo(convertValue(3,armorMax))},
       {name: 'BZN Tank', min: roundToTwo(convertValue(4,bznTankMin)), max: roundToTwo(convertValue(4,bznTankMax))}, {name: 'Speed', min: roundToTwo(convertValue(1,speedMin)), max: roundToTwo(convertValue(1,speedMax))},
       {name: 'Accel.', min: roundToTwo(convertValue(2,accMin)), max: roundToTwo(convertValue(2,accMax))}];

      var json = [ {name: 'Engine', min: roundToTwo(convertValue(engineMin)), max: roundToTwo(engineMax)}, {name: 'Armor', min: roundToTwo(armorMin), max: roundToTwo(armorMax)},
       {name: 'BZN Tank', min: roundToTwo(bznTankMin), max: roundToTwo(bznTankMax)}, {name: 'Speed', min: roundToTwo(speedMin), max: roundToTwo(speedMax)},
       {name: 'Accel.', min: roundToTwo(accMin), max: roundToTwo(accMax)}];

       var diffJson = [ {name: 'Engine', min: roundToTwo(engineMin), max: roundToTwo(engineMax-engineMin)}, {name: 'Armor', min: roundToTwo(armorMin), max: roundToTwo(armorMax-engineMin)},
        {name: 'BZN Tank', min: roundToTwo(bznTankMin), max: roundToTwo(bznTankMax-bznTankMin)}, {name: 'Speed', min: roundToTwo(speedMin), max: roundToTwo(speedMax-speedMin)},
        {name: 'Accel.', min: roundToTwo(accMin), max: roundToTwo(accMax-accMin)}];

        var convDiffJson = [ {name: 'Engine', min: roundToTwo(convertValue(5,engineMin)), max: roundToTwo(convertValue(5,engineMax-engineMin)), title: 100}, {name: 'Armor', min: roundToTwo(convertValue(3,armorMin)), max: roundToTwo(convertValue(3,armorMax-armorMin)), title: 100},
         {name: 'BZN Tank', min: roundToTwo(convertValue(4,bznTankMin)), max: roundToTwo(convertValue(4,bznTankMax-bznTankMin)), title: 100}, {name: 'Speed', min: roundToTwo(convertValue(1,speedMin)), max: roundToTwo(convertValue(1,speedMax-speedMin)), title: 100},
         {name: 'Accel.', min: roundToTwo(convertValue(2,accMin)), max: roundToTwo(convertValue(2,accMax-accMin)), title: 100}];

      return convDiffJson;

    } else if (type == 1) {
      var engineMin=-1,
      engineMax=-1,
      armorMin=-1,
      armorMax=-1,
      bznTankMin=-1,
      bznTankMax=-1,
      speedMin=-1,
      speedMax=-1,
      accMin=-1,
      accMax=-1;
      var t = cars_table_data_minMax.midGrade.map(function(car) {
        if (engineMax != -1 && car.engineMax > engineMax) {
          engineMax = car.engineMax;
        } else if (engineMax == -1) {
          engineMax = car.engineMax;
        }
        if (engineMin != -1 && car.engineMin < engineMin) {
          engineMin = car.engineMin;
        } else if (engineMin == -1) {
          engineMin = car.engineMin;
        }
        if (armorMax != -1 && car.armorMax > armorMax) {
          armorMax = car.armorMax;
        } else if (armorMax == -1) {
          armorMax = car.armorMax;
        }

        if (armorMin != -1 && car.armorMin < armorMin) {
          armorMin = car.armorMin;
        } else if (armorMin == -1) {
          armorMin = car.armorMin;
        }

        if (bznTankMin != -1 && car.bznTankMin < bznTankMin) {
          bznTankMin = car.bznTankMin;
        } else if (bznTankMin == -1) {
          bznTankMin = car.bznTankMin;
        }

        if (bznTankMax != -1 && car.bznTankMax > bznTankMax) {
          bznTankMax = car.bznTankMax;
        } else if (bznTankMax == -1) {
          bznTankMax = car.bznTankMax;
        }

        if (speedMin != -1 && car.speedMin < speedMin) {
          speedMin = car.speedMin;
        } else if (speedMin == -1) {
          speedMin = car.speedMin;
        }

        if (speedMax != -1 && car.speedMax > speedMax) {
          speedMax = car.speedMax;
        } else if (speedMax == -1) {
          speedMax = car.speedMax;
        }

        if (accMin != -1 && car.accMin < accMin) {
          accMin = car.accMin;
        } else if (accMin == -1) {
          accMin = car.accMin;
        }

        if (accMax != -1 && car.accMax > accMax) {
          accMax = car.accMax;
        } else if (accMax == -1) {
          accMax = car.accMax;
        }

      });

      let indices = {
        speed: 1,
        acc: 2,
        armor: 3,
        bznTank: 4,
        engine: 5,
        mainGuns: 6,
        altGuns: 7,
        equipmentSlots: 8,
        nos: 9,
        rateOfFire: 10,
        velocity: 11,
        effectiveRange: 12,
        maxRange: 13
      };

      var convertedJson = [ {name: 'Engine', min: roundToTwo(convertValue(5,engineMin)), max: roundToTwo(convertValue(5,engineMax))}, {name: 'Armor', min: roundToTwo(convertValue(3,armorMin)), max: roundToTwo(convertValue(3,armorMax))},
       {name: 'BZN Tank', min: roundToTwo(convertValue(4,bznTankMin)), max: roundToTwo(convertValue(4,bznTankMax))}, {name: 'Speed', min: roundToTwo(convertValue(1,speedMin)), max: roundToTwo(convertValue(1,speedMax))},
       {name: 'Accel.', min: roundToTwo(convertValue(2,accMin)), max: roundToTwo(convertValue(2,accMax))}];

      var json = [ {name: 'Engine', min: roundToTwo(convertValue(engineMin)), max: roundToTwo(engineMax)}, {name: 'Armor', min: roundToTwo(armorMin), max: roundToTwo(armorMax)},
       {name: 'BZN Tank', min: roundToTwo(bznTankMin), max: roundToTwo(bznTankMax)}, {name: 'Speed', min: roundToTwo(speedMin), max: roundToTwo(speedMax)},
       {name: 'Accel.', min: roundToTwo(accMin), max: roundToTwo(accMax)}];

       var diffJson = [ {name: 'Engine', min: roundToTwo(engineMin), max: roundToTwo(engineMax-engineMin)}, {name: 'Armor', min: roundToTwo(armorMin), max: roundToTwo(armorMax-engineMin)},
        {name: 'BZN Tank', min: roundToTwo(bznTankMin), max: roundToTwo(bznTankMax-bznTankMin)}, {name: 'Speed', min: roundToTwo(speedMin), max: roundToTwo(speedMax-speedMin)},
        {name: 'Accel.', min: roundToTwo(accMin), max: roundToTwo(accMax-accMin)}];

        var convDiffJson = [ {name: 'Engine', min: roundToTwo(convertValue(5,engineMin)), max: roundToTwo(convertValue(5,engineMax-engineMin)), title: roundToTwo(convertValue(5,engineMax))}, {name: 'Armor', min: roundToTwo(convertValue(3,armorMin)), max: roundToTwo(convertValue(3,armorMax-armorMin)), title: roundToTwo(convertValue(3,armorMax))},
         {name: 'BZN Tank', min: roundToTwo(convertValue(4,bznTankMin)), max: roundToTwo(convertValue(4,bznTankMax-bznTankMin)), title: roundToTwo(convertValue(4,bznTankMax))}, {name: 'Speed', min: roundToTwo(convertValue(1,speedMin)), max: roundToTwo(convertValue(1,speedMax-speedMin)), title: roundToTwo(convertValue(1,speedMax))},
         {name: 'Accel.', min: roundToTwo(convertValue(2,accMin)), max: roundToTwo(convertValue(2,accMax-accMin)), title: roundToTwo(convertValue(2,accMax))}];

      return convDiffJson;
    } else {
      var engineMin=-1,
      engineMax=-1,
      armorMin=-1,
      armorMax=-1,
      bznTankMin=-1,
      bznTankMax=-1,
      speedMin=-1,
      speedMax=-1,
      accMin=-1,
      accMax=-1;
      var t = cars_table_data_minMax.regular.map(function(car) {
        if (engineMax != -1 && car.engineMax > engineMax) {
          engineMax = car.engineMax;
        } else if (engineMax == -1) {
          engineMax = car.engineMax;
        }
        if (engineMin != -1 && car.engineMin < engineMin) {
          engineMin = car.engineMin;
        } else if (engineMin == -1) {
          engineMin = car.engineMin;
        }
        if (armorMax != -1 && car.armorMax > armorMax) {
          armorMax = car.armorMax;
        } else if (armorMax == -1) {
          armorMax = car.armorMax;
        }

        if (armorMin != -1 && car.armorMin < armorMin) {
          armorMin = car.armorMin;
        } else if (armorMin == -1) {
          armorMin = car.armorMin;
        }

        if (bznTankMin != -1 && car.bznTankMin < bznTankMin) {
          bznTankMin = car.bznTankMin;
        } else if (bznTankMin == -1) {
          bznTankMin = car.bznTankMin;
        }

        if (bznTankMax != -1 && car.bznTankMax > bznTankMax) {
          bznTankMax = car.bznTankMax;
        } else if (bznTankMax == -1) {
          bznTankMax = car.bznTankMax;
        }

        if (speedMin != -1 && car.speedMin < speedMin) {
          speedMin = car.speedMin;
        } else if (speedMin == -1) {
          speedMin = car.speedMin;
        }

        if (speedMax != -1 && car.speedMax > speedMax) {
          speedMax = car.speedMax;
        } else if (speedMax == -1) {
          speedMax = car.speedMax;
        }

        if (accMin != -1 && car.accMin < accMin) {
          accMin = car.accMin;
        } else if (accMin == -1) {
          accMin = car.accMin;
        }

        if (accMax != -1 && car.accMax > accMax) {
          accMax = car.accMax;
        } else if (accMax == -1) {
          accMax = car.accMax;
        }

     });

     let indices = {
       speed: 1,
       acc: 2,
       armor: 3,
       bznTank: 4,
       engine: 5,
       mainGuns: 6,
       altGuns: 7,
       equipmentSlots: 8,
       nos: 9,
       rateOfFire: 10,
       velocity: 11,
       effectiveRange: 12,
       maxRange: 13
     };
      // Speed, Armor, Guns
      var convertedJson = [ {name: 'Engine', min: roundToTwo(convertValue(5,engineMin)), max: roundToTwo(convertValue(5,engineMax))}, {name: 'Armor', min: roundToTwo(convertValue(3,armorMin)), max: roundToTwo(convertValue(3,armorMax))},
       {name: 'BZN Tank', min: roundToTwo(convertValue(4,bznTankMin)), max: roundToTwo(convertValue(4,bznTankMax))}, {name: 'Speed', min: roundToTwo(convertValue(1,speedMin)), max: roundToTwo(convertValue(1,speedMax))},
       {name: 'Accel.', min: roundToTwo(convertValue(2,accMin)), max: roundToTwo(convertValue(2,accMax))}];

      var json = [ {name: 'Engine', min: roundToTwo(convertValue(engineMin)), max: roundToTwo(engineMax)}, {name: 'Armor', min: roundToTwo(armorMin), max: roundToTwo(armorMax)},
       {name: 'BZN Tank', min: roundToTwo(bznTankMin), max: roundToTwo(bznTankMax)}, {name: 'Speed', min: roundToTwo(speedMin), max: roundToTwo(speedMax)},
       {name: 'Accel.', min: roundToTwo(accMin), max: roundToTwo(accMax)}];

       var diffJson = [ {name: 'Engine', min: roundToTwo(engineMin), max: roundToTwo(engineMax-engineMin)}, {name: 'Armor', min: roundToTwo(armorMin), max: roundToTwo(armorMax-engineMin)},
        {name: 'BZN Tank', min: roundToTwo(bznTankMin), max: roundToTwo(bznTankMax-bznTankMin)}, {name: 'Speed', min: roundToTwo(speedMin), max: roundToTwo(speedMax-speedMin)},
        {name: 'Accel.', min: roundToTwo(accMin), max: roundToTwo(accMax-accMin)}];

        var convDiffJson = [ {name: 'Engine', min: roundToTwo(convertValue(5,engineMin)), max: roundToTwo(convertValue(5,engineMax-engineMin)), title: roundToTwo(convertValue(5,engineMax))}, {name: 'Armor', min: roundToTwo(convertValue(3,armorMin)), max: roundToTwo(convertValue(3,armorMax-armorMin)), title: roundToTwo(convertValue(3,armorMax))},
         {name: 'BZN Tank', min: roundToTwo(convertValue(4,bznTankMin)), max: roundToTwo(convertValue(4,bznTankMax-bznTankMin)), title: roundToTwo(convertValue(4,bznTankMax))}, {name: 'Speed', min: roundToTwo(convertValue(1,speedMin)), max: roundToTwo(convertValue(1,speedMax-speedMin)), title: roundToTwo(convertValue(1,speedMax))},
         {name: 'Accel.', min: roundToTwo(convertValue(2,accMin)), max: roundToTwo(convertValue(2,accMax-accMin)), title: roundToTwo(convertValue(2,accMax))}];

      return convDiffJson;
    }

  }
  ,getRanges: function(type) {
    if (type == 0) {
      var engineMin=-1,
      engineMax=-1,
      armorMin=-1,
      armorMax=-1,
      bznTankMin=-1,
      bznTankMax=-1,
      speedMin=-1,
      speedMax=-1,
      accMin=-1,
      accMax=-1;

      var t = cars_table_data_minMax.premium.map(function(car) {
        if (engineMax != -1 && car.engineMax > engineMax) {
          engineMax = car.engineMax;
        } else if (engineMax == -1) {
          engineMax = car.engineMax;
        }
        if (engineMin != -1 && car.engineMin < engineMin) {
          engineMin = car.engineMin;
        } else if (engineMin == -1) {
          engineMin = car.engineMin;
        }
        if (armorMax != -1 && car.armorMax > armorMax) {
          armorMax = car.armorMax;
        } else if (armorMax == -1) {
          armorMax = car.armorMax;
        }

        if (armorMin != -1 && car.armorMin < armorMin) {
          armorMin = car.armorMin;
        } else if (armorMin == -1) {
          armorMin = car.armorMin;
        }

        if (bznTankMin != -1 && car.bznTankMin < bznTankMin) {
          bznTankMin = car.bznTankMin;
        } else if (bznTankMin == -1) {
          bznTankMin = car.bznTankMin;
        }

        if (bznTankMax != -1 && car.bznTankMax > bznTankMax) {
          bznTankMax = car.bznTankMax;
        } else if (bznTankMax == -1) {
          bznTankMax = car.bznTankMax;
        }

        if (speedMin != -1 && car.speedMin < speedMin) {
          speedMin = car.speedMin;
        } else if (speedMin == -1) {
          speedMin = car.speedMin;
        }

        if (speedMax != -1 && car.speedMax > speedMax) {
          speedMax = car.speedMax;
        } else if (speedMax == -1) {
          speedMax = car.speedMax;
        }

        if (accMin != -1 && car.accMin < accMin) {
          accMin = car.accMin;
        } else if (accMin == -1) {
          accMin = car.accMin;
        }

        if (accMax != -1 && car.accMax > accMax) {
          accMax = car.accMax;
        } else if (accMax == -1) {
          accMax = car.accMax;
        }

      });

        let obj = [engineMin, engineMax, armorMin, armorMax, bznTankMin, bznTankMax, speedMin, speedMax, accMin, accMax];

        let indices = {
          speed: 1,
          acc: 2,
          armor: 3,
          bznTank: 4,
          engine: 5,
          mainGuns: 6,
          altGuns: 7,
          equipmentSlots: 8,
          nos: 9,
          rateOfFire: 10,
          velocity: 11,
          effectiveRange: 12,
          maxRange: 13
        };
      // engine, armor, bzn, speed, acc
      var convertedJson = [ {name: 'Engine', min: roundToTwo(convertValue(5,engineMin)), max: roundToTwo(convertValue(5,engineMax))}, {name: 'Armor', min: roundToTwo(convertValue(3,armorMin)), max: roundToTwo(convertValue(3,armorMax))},
       {name: 'BZN Tank', min: roundToTwo(convertValue(4,bznTankMin)), max: roundToTwo(convertValue(4,bznTankMax))}, {name: 'Speed', min: roundToTwo(convertValue(1,speedMin)), max: roundToTwo(convertValue(1,speedMax))},
       {name: 'Accel.', min: roundToTwo(convertValue(2,accMin)), max: roundToTwo(convertValue(2,accMax))}];

      var json = [ {name: 'Engine', min: roundToTwo(engineMin), max: roundToTwo(engineMax)}, {name: 'Armor', min: roundToTwo(armorMin), max: roundToTwo(armorMax)},
 {name: 'BZN Tank', min: roundToTwo(bznTankMin), max: roundToTwo(bznTankMax)}, {name: 'Speed', min: roundToTwo(speedMin), max: roundToTwo(speedMax)},
       {name: 'Accel.', min: roundToTwo(accMin), max: roundToTwo(accMax)}];

       var diffJson = [ {name: 'Engine', min: roundToTwo(engineMin), max: roundToTwo(engineMax-engineMin)}, {name: 'Armor', min: roundToTwo(armorMin), max: roundToTwo(armorMax-engineMin)},
        {name: 'BZN Tank', min: roundToTwo(bznTankMin), max: roundToTwo(bznTankMax-bznTankMin)}, {name: 'Speed', min: roundToTwo(speedMin), max: roundToTwo(speedMax-speedMin)},
        {name: 'Accel.', min: roundToTwo(accMin), max: roundToTwo(accMax-accMin)}];

        var convDiffJson = [ {name: 'Engine', min: roundToTwo(convertValue(5,engineMin)), max: roundToTwo(convertValue(5,engineMax-engineMin)), title: roundToTwo(convertValue(5,engineMax))}, {name: 'Armor', min: roundToTwo(convertValue(3,armorMin)), max: roundToTwo(convertValue(3,armorMax-armorMin)), title: roundToTwo(convertValue(3,armorMax))},
         {name: 'BZN Tank', min: roundToTwo(convertValue(4,bznTankMin)), max: roundToTwo(convertValue(4,bznTankMax-bznTankMin)), title: roundToTwo(convertValue(4,bznTankMax))}, {name: 'Speed', min: roundToTwo(convertValue(1,speedMin)), max: roundToTwo(convertValue(1,speedMax-speedMin)), title: roundToTwo(convertValue(1,speedMax))},
         {name: 'Accel.', min: roundToTwo(convertValue(2,accMin)), max: roundToTwo(convertValue(2,accMax-accMin)), title: roundToTwo(convertValue(2,accMax))}];

      return json;
    } else if (type == 1) {
      var engineMin=-1,
      engineMax=-1,
      armorMin=-1,
      armorMax=-1,
      bznTankMin=-1,
      bznTankMax=-1,
      speedMin=-1,
      speedMax=-1,
      accMin=-1,
      accMax=-1;

      var t = cars_table_data_minMax.midGrade.map(function(car) {
        if (engineMax != -1 && car.engineMax > engineMax) {
          engineMax = car.engineMax;
        } else if (engineMax == -1) {
          engineMax = car.engineMax;
        }
        if (engineMin != -1 && car.engineMin < engineMin) {
          engineMin = car.engineMin;
        } else if (engineMin == -1) {
          engineMin = car.engineMin;
        }
        if (armorMax != -1 && car.armorMax > armorMax) {
          armorMax = car.armorMax;
        } else if (armorMax == -1) {
          armorMax = car.armorMax;
        }

        if (armorMin != -1 && car.armorMin < armorMin) {
          armorMin = car.armorMin;
        } else if (armorMin == -1) {
          armorMin = car.armorMin;
        }

        if (bznTankMin != -1 && car.bznTankMin < bznTankMin) {
          bznTankMin = car.bznTankMin;
        } else if (bznTankMin == -1) {
          bznTankMin = car.bznTankMin;
        }

        if (bznTankMax != -1 && car.bznTankMax > bznTankMax) {
          bznTankMax = car.bznTankMax;
        } else if (bznTankMax == -1) {
          bznTankMax = car.bznTankMax;
        }

        if (speedMin != -1 && car.speedMin < speedMin) {
          speedMin = car.speedMin;
        } else if (speedMin == -1) {
          speedMin = car.speedMin;
        }

        if (speedMax != -1 && car.speedMax > speedMax) {
          speedMax = car.speedMax;
        } else if (speedMax == -1) {
          speedMax = car.speedMax;
        }

        if (accMin != -1 && car.accMin < accMin) {
          accMin = car.accMin;
        } else if (accMin == -1) {
          accMin = car.accMin;
        }

        if (accMax != -1 && car.accMax > accMax) {
          accMax = car.accMax;
        } else if (accMax == -1) {
          accMax = car.accMax;
        }

      });

        let obj = [engineMin, engineMax, armorMin, armorMax, bznTankMin, bznTankMax, speedMin, speedMax, accMin, accMax];

        let indices = {
          speed: 1,
          acc: 2,
          armor: 3,
          bznTank: 4,
          engine: 5,
          mainGuns: 6,
          altGuns: 7,
          equipmentSlots: 8,
          nos: 9,
          rateOfFire: 10,
          velocity: 11,
          effectiveRange: 12,
          maxRange: 13
        };
      // engine, armor, bzn, speed, acc
      var convertedJson = [ {name: 'Engine', min: roundToTwo(convertValue(5,engineMin)), max: roundToTwo(convertValue(5,engineMax))}, {name: 'Armor', min: roundToTwo(convertValue(3,armorMin)), max: roundToTwo(convertValue(3,armorMax))},
       {name: 'BZN Tank', min: roundToTwo(convertValue(4,bznTankMin)), max: roundToTwo(convertValue(4,bznTankMax))}, {name: 'Speed', min: roundToTwo(convertValue(1,speedMin)), max: roundToTwo(convertValue(1,speedMax))},
       {name: 'Accel.', min: roundToTwo(convertValue(2,accMin)), max: roundToTwo(convertValue(2,accMax))}];

      var json = [ {name: 'Engine', min: roundToTwo(engineMin), max: roundToTwo(engineMax)}, {name: 'Armor', min: roundToTwo(armorMin), max: roundToTwo(armorMax)},
       {name: 'BZN Tank', min: roundToTwo(bznTankMin), max: roundToTwo(bznTankMax)}, {name: 'Speed', min: roundToTwo(speedMin), max: roundToTwo(speedMax)},
       {name: 'Accel.', min: roundToTwo(accMin), max: roundToTwo(accMax)}];

       var diffJson = [ {name: 'Engine', min: roundToTwo(engineMin), max: roundToTwo(engineMax-engineMin)}, {name: 'Armor', min: roundToTwo(armorMin), max: roundToTwo(armorMax-engineMin)},
        {name: 'BZN Tank', min: roundToTwo(bznTankMin), max: roundToTwo(bznTankMax-bznTankMin)}, {name: 'Speed', min: roundToTwo(speedMin), max: roundToTwo(speedMax-speedMin)},
        {name: 'Accel.', min: roundToTwo(accMin), max: roundToTwo(accMax-accMin)}];

        var convDiffJson = [ {name: 'Engine', min: roundToTwo(convertValue(5,engineMin)), max: roundToTwo(convertValue(5,engineMax-engineMin)), title: roundToTwo(convertValue(5,engineMax))}, {name: 'Armor', min: roundToTwo(convertValue(3,armorMin)), max: roundToTwo(convertValue(3,armorMax-armorMin)), title: roundToTwo(convertValue(3,armorMax))},
         {name: 'BZN Tank', min: roundToTwo(convertValue(4,bznTankMin)), max: roundToTwo(convertValue(4,bznTankMax-bznTankMin)), title: roundToTwo(convertValue(4,bznTankMax))}, {name: 'Speed', min: roundToTwo(convertValue(1,speedMin)), max: roundToTwo(convertValue(1,speedMax-speedMin)), title: roundToTwo(convertValue(1,speedMax))},
         {name: 'Accel.', min: roundToTwo(convertValue(2,accMin)), max: roundToTwo(convertValue(2,accMax-accMin)), title: roundToTwo(convertValue(2,accMax))}];

      return json;
    } else if (type == 2) {
      var engineMin=-1,
      engineMax=-1,
      armorMin=-1,
      armorMax=-1,
      bznTankMin=-1,
      bznTankMax=-1,
      speedMin=-1,
      speedMax=-1,
      accMin=-1,
      accMax=-1;

      var t = cars_table_data_minMax.regular.map(function(car) {
        if (engineMax != -1 && car.engineMax > engineMax) {
          engineMax = car.engineMax;
        } else if (engineMax == -1) {
          engineMax = car.engineMax;
        }
        if (engineMin != -1 && car.engineMin < engineMin) {
          engineMin = car.engineMin;
        } else if (engineMin == -1) {
          engineMin = car.engineMin;
        }
        if (armorMax != -1 && car.armorMax > armorMax) {
          armorMax = car.armorMax;
        } else if (armorMax == -1) {
          armorMax = car.armorMax;
        }

        if (armorMin != -1 && car.armorMin < armorMin) {
          armorMin = car.armorMin;
        } else if (armorMin == -1) {
          armorMin = car.armorMin;
        }

        if (bznTankMin != -1 && car.bznTankMin < bznTankMin) {
          bznTankMin = car.bznTankMin;
        } else if (bznTankMin == -1) {
          bznTankMin = car.bznTankMin;
        }

        if (bznTankMax != -1 && car.bznTankMax > bznTankMax) {
          bznTankMax = car.bznTankMax;
        } else if (bznTankMax == -1) {
          bznTankMax = car.bznTankMax;
        }

        if (speedMin != -1 && car.speedMin < speedMin) {
          speedMin = car.speedMin;
        } else if (speedMin == -1) {
          speedMin = car.speedMin;
        }

        if (speedMax != -1 && car.speedMax > speedMax) {
          speedMax = car.speedMax;
        } else if (speedMax == -1) {
          speedMax = car.speedMax;
        }

        if (accMin != -1 && car.accMin < accMin) {
          accMin = car.accMin;
        } else if (accMin == -1) {
          accMin = car.accMin;
        }

        if (accMax != -1 && car.accMax > accMax) {
          accMax = car.accMax;
        } else if (accMax == -1) {
          accMax = car.accMax;
        }

      });

        let obj = [engineMin, engineMax, armorMin, armorMax, bznTankMin, bznTankMax, speedMin, speedMax, accMin, accMax];

        let indices = {
          speed: 1,
          acc: 2,
          armor: 3,
          bznTank: 4,
          engine: 5,
          mainGuns: 6,
          altGuns: 7,
          equipmentSlots: 8,
          nos: 9,
          rateOfFire: 10,
          velocity: 11,
          effectiveRange: 12,
          maxRange: 13
        };
      // engine, armor, bzn, speed, acc
      var convertedJson = [ {name: 'Engine', min: roundToTwo(convertValue(5,engineMin)), max: roundToTwo(convertValue(5,engineMax))}, {name: 'Armor', min: roundToTwo(convertValue(3,armorMin)), max: roundToTwo(convertValue(3,armorMax))},
       {name: 'BZN Tank', min: roundToTwo(convertValue(4,bznTankMin)), max: roundToTwo(convertValue(4,bznTankMax))}, {name: 'Speed', min: roundToTwo(convertValue(1,speedMin)), max: roundToTwo(convertValue(1,speedMax))},
       {name: 'Accel.', min: roundToTwo(convertValue(2,accMin)), max: roundToTwo(convertValue(2,accMax))}];

      var json = [ {name: 'Engine', min: roundToTwo(engineMin), max: roundToTwo(engineMax)}, {name: 'Armor', min: roundToTwo(armorMin), max: roundToTwo(armorMax)},
       {name: 'BZN Tank', min: roundToTwo(bznTankMin), max: roundToTwo(bznTankMax)}, {name: 'Speed', min: roundToTwo(speedMin), max: roundToTwo(speedMax)},
       {name: 'Accel.', min: roundToTwo(accMin), max: roundToTwo(accMax)}];

       var diffJson = [ {name: 'Engine', min: roundToTwo(engineMin), max: roundToTwo(engineMax-engineMin)}, {name: 'Armor', min: roundToTwo(armorMin), max: roundToTwo(armorMax-engineMin)},
        {name: 'BZN Tank', min: roundToTwo(bznTankMin), max: roundToTwo(bznTankMax-bznTankMin)}, {name: 'Speed', min: roundToTwo(speedMin), max: roundToTwo(speedMax-speedMin)},
        {name: 'Accel.', min: roundToTwo(accMin), max: roundToTwo(accMax-accMin)}];

        var convDiffJson = [ {name: 'Engine', min: roundToTwo(convertValue(5,engineMin)), max: roundToTwo(convertValue(5,engineMax-engineMin)), title: roundToTwo(convertValue(5,engineMax))}, {name: 'Armor', min: roundToTwo(convertValue(3,armorMin)), max: roundToTwo(convertValue(3,armorMax-armorMin)), title: roundToTwo(convertValue(3,armorMax))},
         {name: 'BZN Tank', min: roundToTwo(convertValue(4,bznTankMin)), max: roundToTwo(convertValue(4,bznTankMax-bznTankMin)), title: roundToTwo(convertValue(4,bznTankMax))}, {name: 'Speed', min: roundToTwo(convertValue(1,speedMin)), max: roundToTwo(convertValue(1,speedMax-speedMin)), title: roundToTwo(convertValue(1,speedMax))},
         {name: 'Accel.', min: roundToTwo(convertValue(2,accMin)), max: roundToTwo(convertValue(2,accMax-accMin)), title: roundToTwo(convertValue(2,accMax))}];

      return json;
    } else if (type == 3) {
      return [
        {
          min: roundToTwo(60),
          max: roundToTwo(600)
        },
        {
          min: roundToTwo(350),
          max: roundToTwo(985)
        },
        {
          min: roundToTwo(276),
          max: roundToTwo(776)
        },
        {
          min: roundToTwo(1102),
          max: roundToTwo(3089)
        }
      ]
    } else if (type == 4) {
      return [{
        min: roundToTwo(50),
        max: roundToTwo(570)
      },
      {
        min: roundToTwo(300),
        max: roundToTwo(930)
      },
      {
        min: roundToTwo(236),
        max: roundToTwo(732)
      },
      {
        min: roundToTwo(945),
        max: roundToTwo(2918)
      }]
    } else if (type == 5) {
      return [{
        min: roundToTwo(40),
        max: roundToTwo(550)
      },
      {
        min: roundToTwo(230),
        max: roundToTwo(900)
      },
      {
        min: roundToTwo(181),
        max: roundToTwo(709)
      },
      {
        min: roundToTwo(724),
        max: roundToTwo(2824)
      }]
    } else if (type == 6) {
      return [
        {
          min: roundToTwo(70),
          max: roundToTwo(100)
        },
        {
          min: roundToTwo(70),
          max: roundToTwo(100)
        },
        {
          min: roundToTwo(10),
          max: roundToTwo(30)
        },
        {
          min: roundToTwo(4),
          max: roundToTwo(7)
        },
        {
          min: roundToTwo(7),
          max: roundToTwo(10)
        },
        {
          min: roundToTwo(7),
          max: roundToTwo(10)
        },
        {
          min: roundToTwo(1),
          max: roundToTwo(10)
        },
      ]
    } else if (type == 7) {
      return [{
        min: roundToTwo(40),
        max: roundToTwo(70)
      },
      {
        min: roundToTwo(40),
        max: roundToTwo(70)
      },
      {
        min: roundToTwo(10),
        max: roundToTwo(30)
      },
      {
        min: roundToTwo(4),
        max: roundToTwo(7)
      },
      {
        min: roundToTwo(4),
        max: roundToTwo(7)
      },
      {
        min: roundToTwo(4),
        max: roundToTwo(7)
      },
      {
        min: roundToTwo(1),
        max: roundToTwo(7)
      }]
    } else {
      return [{
        min: roundToTwo(5),
        max: roundToTwo(40)
      },
      {
        min: roundToTwo(5),
        max: roundToTwo(40)
      },
      {
        min: roundToTwo(10),
        max: roundToTwo(30)
      },
      {
        min: roundToTwo(4),
        max: roundToTwo(7)
      },
      {
        min: roundToTwo(1),
        max: roundToTwo(4)
      },
      {
        min: roundToTwo(1),
        max: roundToTwo(4)
      },
      {
        min: roundToTwo(1),
        max: roundToTwo(4)
      }]
    }

  }
};

setupContracts();

function roundToTwo(num) {
    return +(Math.round(num + "e+2")  + "e-2");
}

export default variables;
